<template>
  <div id="main-box">

    <!-- 顶部 -->
    <div class="BulkTopBox">
      <div class="BulkTop">

        <!-- 店铺&类目 -->
        <section v-if="navList[0].active">
          <table class="layui-table layui-form" :id="'shop-box'+pindex" v-for="(item,pindex) in list" ::key="item.id">
            <thead>
              <tr>
                <th class="list-index">编号</th>
                <th class="img-width">图片</th>
                <th>类目&属性（{{item.data.name}}）</th>
                <th class="btnArr-width">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-text="pindex+1"></td>
                <td v-viewer>
                  <img class="table_img" :src="$picture(item.image)">
                </td>
                <td>
                  <div class="col-data">
                    <div class="col-row" :class="{'marginTop':item.data.attributes.length == 0}">
                      <div class="col-left"><a><i class="required">*</i>商品分类(classify)</a></div>
                      <div class="col-right layui-form col-classify-box">
                        <button class="layui-btn layui-btn-primary" type="button" lay-submit v-on:click="ShowClassify(pindex)">选择分类</button>
                        <a class="col-classify" v-if="item.data.categories.length > 0">
                          <a v-for="(classify,index) in item.data.categories">
                            <i v-if="classify.display_name_zh" v-text="classify.display_name_zh+'「'+classify.display_name+'」'"></i>
                            <i v-else v-text="classify.display_name"></i>
                            <i v-if="index != (item.data.categories.length-1)" v-text="' > '"></i>
                          </a>
                          <a class="redColor">
                            <i v-if="item.data.isSpecial == 0">（普货）</i>
                            <i v-if="item.data.isSpecial == 1">（特货）</i>
                          </a>
                          <a class="col-classify-used-set" v-on:click="SetUsedClassify">设为常用</a>
                        </a>
                        <a v-else class="col-classify redtxt">
                          *请选择分类
                        </a>
                        <a class="col-classify-used" v-on:click="ShowUsedClassify(pindex)"><i class="fa fa-book" ></i> 常用分类</a>
                      </div>
                    </div>
                  </div>

                  <div class="col-data" style="padding-bottom: 20px;">
                    <div class="col-data-left" v-for="(attr,index) in item.data.attributes" :key="attr.attribute_id">
                      <div class="col-row">
                        <div class="col-left tipsBox" :class="'tips'+pindex+index" :data-pix="pindex" :data-ix="index">
                          <div class="col-attribute">
                            <a>
                              <i class="col-left-data" v-if="attr.display_attribute_name"><span class="required" v-if="attr.is_mandatory">*</span>{{attr.display_attribute_name}}({{attr.original_attribute_name}})</i>
                              <i class="col-left-data" v-else><span class="required" v-if="attr.is_mandatory">*</span>{{attr.original_attribute_name}}</i>
                            </a>
                          </div>
                        </div>

                        <!-- 输入框 -->
                        <div class="col-right layui-form col-right-select" v-if="attr.input_type == 'TEXT_FILED' && attr.input_validation_type == 'DATE_TYPE'">
                          <input type="text" v-model="attr.current_select_en" class="input-box layui-input" placeholder="格式:2022-02-22"
                            autocomplete="off">
                        </div>

                        <!-- 输入框 -->
                        <div class="col-right layui-form col-right-select" v-else-if="attr.input_type == 'TEXT_FILED'">
                          <input type="text" v-model="attr.current_select_en" class="input-box layui-input" placeholder="在此输入内容"
                            autocomplete="off">

                            <select type="text" lay-filter="unit_select_box" autocomplete="off" class="layui-select" lay-search v-if="attr.attribute_unit.length > 0">
                              <option v-for="(unit,ix) in attr.attribute_unit" :data-ix="index" :data-six="ix" :data-pindex="pindex" :selected="unit == attr.current_select_value_unit" v-text="unit"></option>
                            </select>
                        </div>

                        <!-- 下拉框 -->
                        <div class="col-right layui-form" v-else>
                          <!-- <input type="text" style="width: calc(100% - 40px);" class="search-input layui-input" v-on:input="inputFun"
                            :data-ix="index" v-model="attr.current_select" placeholder="可输入查询" autocomplete="off" :required="attr.is_mandatory"> -->
                          <select type="text" lay-filter="select_box" autocomplete="off" class="layui-select"
                            lay-search>
                            <option v-if="!attr.current_select"></option>
                            <option v-for="(option,ix) in attr.attribute_value_list" v-text="option.original_value_name+'('+option.display_value_name+')'"
                              :data-name="option.original_value_name" :data-aid="option.value_id" :data-ix="index"
                              :data-six="ix" :data-pindex="pindex" :selected="option.original_value_name == attr.current_select_en"></option>
                          </select>
                        </div>

                      </div>
                    </div>
                  </div>

                </td>
                <td class="btn-arr">
                  <button class="layui-btn" v-on:click="ReductionItem(pindex,0)">还原</button>
                  <button class="layui-btn layui-btn-normal" v-on:click="Origin(item.origin)">来源</button>
                  <button class="layui-btn layui-btn-danger" v-on:click="RemoveItem(pindex)">移除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <!-- 店铺&类目 -->

        <!-- 基本信息 -->
        <table class="layui-table" v-if="navList[1].active">
          <thead>
            <tr>
              <th class="list-index">编号</th>
              <th class="img-width">图片</th>
              <th>商品货号</th>
              <th>商品标题</th>
              <th>商品描述</th>
              <th class="btnArr-width">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr :id="'basic-box'+pindex" v-for="(item,pindex) in list">
              <td>{{pindex+1}}</td>
              <td v-viewer>
                <img class="table_img" :src="$picture(item.image)">
              </td>
              <td>
                <input style="width: 150px;" class="BulkInput" type="text" v-model="item.data.ProductCode" />
              </td>
              <td>
                <div class="textarea-box" :class="{redborder:item.data.titleHint}">
                  <textarea class="BulkTextarea" v-on:input="TitleCheck(pindex,1)" v-model="item.data.name"></textarea>
                  <a class="BulkWordLimit">
                    <i v-text="item.data.namelength"></i>
                    /
                    <i>180</i>
                  </a>

                  <!-- 标题提示 -->
                  <div class="title-hint bulk-title-hint" v-if="item.data.titleHint">
                    <i v-text="item.data.titleHintTxt"></i>
                    <i class="layui-icon title-hint-icon"></i>
                  </div>
                </div>
              </td>
              <td>
                <div class="textarea-box" :class="{redborder:item.data.desHint}">
                  <textarea class="BulkTextarea" v-on:input="TitleCheck(pindex,2)" v-model="item.data.description"></textarea>
                  <a class="BulkWordLimit">
                    <i v-text="item.data.deslength"></i>
                    /
                    <i>5000</i>
                  </a>

                  <!-- 描述提示 -->
                  <div class="title-hint bulk-title-hint" v-if="item.data.desHint">
                    <i v-text="item.data.desHintTxt"></i>
                    <i class="layui-icon title-hint-icon"></i>
                  </div>
                </div>
              </td>
              <td class="btn-arr">
                <button class="layui-btn" v-on:click="ReductionItem(pindex,1)">还原</button>
                <button class="layui-btn layui-btn-normal"><a target="_blank" :href="item.origin">来源</a></button>
                <button class="layui-btn layui-btn-danger" v-on:click="RemoveItem(pindex)">移除</button>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 基本信息 -->


        <!-- 图片&视频 -->
        <div v-if="navList[2].active">

          <div class="img-list-row col-block offset-box" :id="'img-box'+pindex" v-for="(item,pindex) in list">
            <div class="col-title-box">
              <a class="col-title">[{{pindex+1}}] {{item.data.name}}</a>
              <button class="layui-btn layui-btn-primary col-title-btn" v-on:click="RemoveItem(pindex)">移除</button>
            </div>
            <div class="images-box">

              <div class="images-head">
                <div class="images-head-left">
                  图片数 <a v-text="item.data.images.length+'/9'" :class="{'hint-red':item.data.images.length>9,'hint-green':item.data.images.length<=9}"></a>
                </div>
                <div class="images-head-right layui-form">
                  <a class="all-img" :class="{'all-img-active':item.data.allImg}" style="padding-right:0;">
                    <input type="checkbox" name="allimg" lay-filter="allimg" data-etype="pro" lay-skin="primary" :data-pindex="pindex"
                      title="全选" :checked="item.data.allImg">
                  </a>
                  <a class="all-img" v-on:click="OperateImg(1,pindex)">保留选中</a>
                  <a class="all-img" v-on:click="OperateImg(2,pindex)">删除选中</a>
                  <a class="all-img" v-on:click="ShowWaterPrint(pindex,'pro')">添加水印</a>
                  <a class="all-img" v-on:click="RestorePicture(pindex,'pro')">恢复图片</a>
                  <button class="layui-btn" type="button" lay-submit v-on:click="KeepPicture(pindex)" v-if="item.data.images.length > 9">保留前9张</button>
                  <button class="layui-btn translation-img" v-on:mouseover="TriggerPulldown(pindex,'pro')">
                    图片翻译
                    <i class="layui-icon layui-icon-down layui-font-12"></i>
                  </button>
                </div>
              </div>

              <div class="col-row">
                <div class="col-left">商品图片</div>
                <div class="col-right">
                  <ul class="col-imglist">
                    <draggable animation="300" filter=".col-select" v-model="item.data.images" v-viewer>
                      <li v-for="(img,imgindex) in item.data.images" :class="{'img-active':img.isActive}">
                        <div class="col-img layui-form" :style="{'background-image': 'url('+$picture(img.url)+')'}">
                          <img style="opacity: 0;" :src="$picture(img.url)">
                          <i class="col-select">
                            <input clas="col-select-checkbox" type="checkbox" lay-skin="primary" :checked="img.isActive">
                          </i>
                          <a class="col-img-size" v-if="img.size" v-text="img.size"></a>
                          <a class="col-select-box NoSelect" data-etype="pro" :data-pindex="pindex" :data-imgindex="imgindex"></a>
                          <p class="col-imglist-btn" v-if="img.url">
                            <a class="col-imglist-btn-a" v-on:click="beautifyImg('pro',pindex,imgindex,$picture(img.url))"><i class="fa fa-pencil-square-o"></i> 美化</a>
                            <a class="col-imglist-btn-a" v-on:click="deletefile(pindex,imgindex)"><i class="fa fa-trash-o"></i> 删除</a>
                          </p>
                        </div>
                        <p class="col-txt" v-if="imgindex == 0">* 封面照片</p>
                        <p class="col-txt" v-else>图片 {{imgindex+1}}</p>
                      </li>
                    </draggable>

                    <li>
                      <p class="col-img">
                        <a class="col-img-btn" v-on:click="PictureSelection(pindex,'pro','产品图片')"><i class="layui-icon">&#xe624;</i> 产品图片</a>
                        <a class="col-img-btn" v-on:click="PictureSelection(pindex,'pro','空间图片')"><i class="layui-icon">&#xe624;</i> 空间图片</a>
                        <a class="col-img-btn" v-on:click="WebPicture(pindex,'pro')"><i class="layui-icon">&#xe624;</i> 网络图片</a>
                        <a class="col-img-btn">
                          <i class="layui-icon">&#xe624;</i> 本地上传
                          <input accept="image/*" class="addimginput upload_img" data-te="pro" :data-pindex="pindex" multiple type="file" name="img">
                        </a>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- 图片&视频 -->

        <!-- SKU -->
        <section v-if="navList[3].active">
          <table class="layui-table" :id="'sku-box'+pindex" v-for="(item,pindex) in list">
            <thead>
              <tr>
                <th class="list-index">编号</th>
                <th class="img-width">图片</th>
                <th>SKU属性（{{item.data.name}}）</th>
                <th class="btnArr-width">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-text="pindex+1"></td>
                <td v-viewer>
                  <img class="table_img" :src="$picture(item.image)">
                </td>
                <td>

                  <div class="col-row marginTop Nopadding">
                    <div class="col-left"><a><i class="required">*</i>商品类型</a></div>
                    <div class="col-right layui-form">
                      <div class="layui-input-inline">
                        <input type="radio" :name="'sku'+pindex" value="false" title="单SKU商品" lay-filter="sku"
                          :data-pindex="pindex" :checked="!item.data.is_tier_variations">
                        <input type="radio" :name="'sku'+pindex" value="true" title="多SKU商品" lay-filter="sku"
                          :data-pindex="pindex" :checked="item.data.is_tier_variations">
                      </div>
                      <a class="col-classify-used" style="right:95px;" v-on:click="SetUsedSku(pindex)"><i class="fa fa-star" ></i> 收藏SKU</a>
                      <a class="col-classify-used" v-on:click="ShowUsedSku(pindex)"><i class="fa fa-book" ></i> 常用SKU</a>
                    </div>
                  </div>

                  <!-- 单SKU -->
                  <section v-if="!item.data.is_tier_variations">

                  </section>
                  <!-- 单SKU -->

                  <!-- 多SKU -->
                  <section v-else>
                    <div class="offset-box">
                      <div class="col-data" v-for="(model,index) in item.data.tier_variations">
                        <div class="col-data-left" style="width:300px;">
                          <div class="col-row Nopadding">
                            <div class="col-left"><a><i class="required">*</i>SKU属性</a></div>
                            <div class="col-right layui-form">
                              <input v-model="model.name" class="col-right-form" />
                              <i class="fa fa-trash-o col-right-icon" v-on:click="deleteSku(pindex,1,index)"></i>
                            </div>
                          </div>
                        </div>
                        <div class="col-data-right" style="width: calc(100% - 320px);margin-left: 20px;">
                          <div class="col-row Nopadding">
                            <ul class="col-sku-box">
                              <li class="col-sku-head">
                                <a>属性值(不能超过30个字符)</a>
                                <a class="auto-sku layui-btn layui-btn-primary" v-on:click="AutoSku(pindex,index)">自动生成</a>
                                <a class="auto-sku layui-btn layui-btn-primary" v-on:click="Reduction(pindex,index)">还原SKU</a>
                                <a class="auto-sku layui-btn layui-btn-primary" v-on:click="UnitConversion(pindex,index)">斤转kg</a>
                                <a class="auto-sku layui-btn layui-btn-primary sku-replace" :data-pix="pindex" :data-six="index">关键词替换</a>
                                <a v-text="model.options.length"></a>
                              </li>
                              <li class="col-sku-main">
                                <div class="col-sku-data">
                                  <div class="col-sku-top NoSelect">
                                    <draggable animation="300" v-model="model.options" @end="onEnd" :data-pix="pindex" :data-ix="index">
                                      <div class="col-sku-block" v-for="(option,ix) in model.options" :class="{'redborder':model.len[ix] > 30}">
                                        <i>{{option}}</i>
                                        <span>
                                          <i v-text="model.len[ix]"></i>
                                          <i class="fa fa-edit" v-on:click="EditSku(pindex,index,ix,option)"></i>
                                          <i v-on:click="deleteSku(pindex,2,index,ix)" class="fa fa-remove"></i>
                                        </span>
                                      </div>
                                    </draggable>
                                  </div>
                                  <div class="col-sku-bottom">
                                    <input class="col-sku-input" :data-ix="index" :data-pindex="pindex" placeholder="在此输入SKU回车添加, SKU可拖动排序, SKU总数不能超过50个" />
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="add-skut" v-on:click="AddSku(pindex)" v-if="item.data.tier_variations.length < 2"><i
                          class="fa fa-plus"></i>添加属性</div>

                    </div>

                    <div class="images-box">
                      <div class="images-head">
                        <div class="images-head-right layui-form">
                          <a class="all-img" :class="{'all-img-active':item.data.allSkuImg}" style="padding-right:0;">
                            <input type="checkbox" name="allimg" lay-filter="allimg" data-etype="sku" lay-skin="primary" :data-pindex="pindex"
                              title="全选" :checked="item.data.allSkuImg">
                          </a>
                          <a class="all-img" v-on:click="OperateImg(1,pindex,'sku')">保留选中</a>
                          <a class="all-img" v-on:click="OperateImg(2,pindex,'sku')">删除选中</a>
                          <a class="all-img" v-on:click="ShowWaterPrint(pindex,'sku')">添加水印</a>
                          <a class="all-img" v-on:click="RestorePicture(pindex,'sku')">恢复图片</a>
                          <button class="layui-btn translation-img" v-on:mouseover="TriggerPulldown(pindex,'sku')">
                            图片翻译
                            <i class="layui-icon layui-icon-down layui-font-12"></i>
                          </button>
                        </div>
                      </div>

                      <div v-for="model in item.data.tier_variations">
                        <div class="col-row Nopadding" v-if="model.images && model.images.length > 0">
                          <div class="col-left"><a v-text="model.name"></a></div>
                          <div class="col-right">
                            <ul class="col-imglist" v-viewer>
                              <draggable animation="300" v-model="model.images">
                                <li v-for="(img,index) in model.images" :class="{'img-active':img && img.isActive}">
                                  <div v-if="img && img.url" class="col-img layui-form" :style="{'background-image': 'url('+$picture(img.url)+')'}">
                                    <img :src="$picture(img.url)" style="opacity:0;">
                                    <i class="col-select">
                                      <input clas="col-select-checkbox" type="checkbox" lay-skin="primary" :checked="img.isActive">
                                    </i>
                                    <a class="col-img-size" v-if="img.size" v-text="img.size"></a>
                                    <a class="col-select-box NoSelect" data-etype="sku" :data-pindex="pindex" :data-imgindex="index"></a>
                                    <p class="col-imglist-btn" v-if="img.url">
                                      <a class="col-imglist-btn-a" v-on:click="beautifyImg('sku',pindex,index,$picture(img.url))"><i class="fa fa-pencil-square-o"></i> 美化</a>
                                      <a class="col-imglist-btn-a" v-on:click="deletefile(pindex,index,2)"><i class="fa fa-trash-o"></i> 删除</a>
                                    </p>
                                  </div>
                                  <p v-else class="col-img">
                                    <a class="col-img-btn" v-on:click="PictureSelection(pindex,'sku','产品图片',index)"><i
                                        class="layui-icon">&#xe624;</i> 产品图片</a>
                                    <a class="col-img-btn" v-on:click="PictureSelection(pindex,'sku','空间图片',index)"><i
                                        class="layui-icon">&#xe624;</i> 空间图片</a>
                                    <a class="col-img-btn" v-on:click="WebPicture(pindex,'sku',index)"><i class="layui-icon">&#xe624;</i>
                                      网络图片</a>
                                    <a class="col-img-btn">
                                      <i class="layui-icon">&#xe624;</i> 本地上传
                                      <input accept="image/*" class="addimginput upload_img" data-te="sku" :data-ix="index"
                                        :data-pindex="pindex" type="file" name="img">
                                    </a>
                                  </p>
                                  <p style="width: 135px;" class="col-txt onlyOneRow" v-text="model.options[index]"></p>
                                </li>
                              </draggable>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                  </section>
                  <!-- 多SKU -->

                  <div class="col-row Nopadding">
                    <div class="col-left"><a>尺码图表</a></div>
                    <div class="col-right">
                        <ul class="col-imglist">
                          <li v-if="item.data.size_chart_info.size_chart">
                            <div class="col-img layui-form" :style="{'background-image': 'url('+item.data.size_chart_info.size_chart+')'}">
                              <img style="opacity: 0;" :src="item.data.size_chart_info.size_chart">
                              <p class="col-imglist-btn" v-if="item.data.size_chart_info.size_chart">
                                <a class="col-imglist-btn-a" v-on:click="beautifyImg(pindex, 'size', 0, item.data.size_chart_info.size_chart)"><i class="fa fa-pencil-square-o"></i> 美化</a>
                                <a class="col-imglist-btn-a" v-on:click="deletefile(pindex, 0, 3)"><i class="fa fa-trash-o"></i> 删除</a>
                              </p>
                            </div>
                          </li>
                          <li v-else>
                            <p class="col-img">
                              <a class="col-img-btn" v-on:click="PictureSelection(pindex, 'size','产品图片')"><i class="layui-icon">&#xe624;</i> 产品图片</a>
                              <a class="col-img-btn" v-on:click="PictureSelection(pindex, 'size','空间图片')"><i class="layui-icon">&#xe624;</i> 空间图片</a>
                              <a class="col-img-btn" v-on:click="WebPicture(pindex, 'size')"><i class="layui-icon">&#xe624;</i> 网络图片</a>
                              <a class="col-img-btn">
                                <i class="layui-icon">&#xe624;</i> 本地上传
                                <input accept="image/*" class="addimginput upload_img" data-te="size" :data-ix="0" :data-pindex="pindex" type="file" name="img">
                              </a>
                            </p>
                          </li>
                        </ul>
                    </div>
                  </div>

                  <!-- 属性信息 -->

                </td>
                <td class="btn-arr">
                  <button class="layui-btn" v-on:click="ReductionItem(pindex,3)">还原</button>
                  <button class="layui-btn layui-btn-normal" v-on:click="Origin(item.origin)">来源</button>
                  <button class="layui-btn layui-btn-danger" v-on:click="RemoveItem(pindex)">移除</button>
                </td>
              </tr>

            </tbody>
          </table>
        </section>
        <!-- SKU -->


        <!-- 折扣&定价 -->
        <section v-if="navList[4].active">
          <table class="layui-table" :id="'sku-table'+pindex" v-for="(item,pindex) in list">
            <thead>
              <tr>
                <th class="list-index">编号</th>
                <th class="img-width">图片</th>
                <th>SKU属性（{{item.data.name}}）</th>
                <th class="btnArr-width">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-text="pindex+1"></td>
                <td v-viewer>
                  <img class="table_img" :src="$picture(item.image)">
                </td>
                <td>

                  <table class="layui-table layui-form">
                    <thead>
                      <tr>
                        <th v-if="item.data.is_tier_variations" v-for="sku in item.data.tier_variations">
                          <i v-if="sku.name" v-text="sku.name"></i>
                          <i v-else>規格名稱</i>
                        </th>
                        <th v-if="item.data.is_tier_variations" class="BulkEditTips" :class="'Tips_name'+pindex" :data-pix="pindex" data-te="name">SKU编号 <i
                            class="fa fa-file-text-o"></i></th>
                        <th class="BulkEditTips" :class="'Tips_price'+pindex" :data-pix="pindex" data-te="price">销售价 <i
                            class="fa fa-file-text-o"></i></th>
                        <th v-if="item.data.is_tier_variations" class="BulkEditTips" :class="'Tips_weight'+pindex" :data-pix="pindex" data-te="weight">重量 <i
                            class="fa fa-file-text-o"></i></th>
                        <th class="BulkEditTips" :class="'Tips_stock'+pindex" :data-pix="pindex" data-te="stock">库存 <i
                            class="fa fa-file-text-o"></i></th>
                      </tr>
                    </thead>
                    <tbody v-if="item.data.is_tier_variations">
                      <tr v-for="(val,ix) in item.data.customize_tier_variations">
                        <td v-if="item.data.tier_variations.length > 0">
                          <i v-if="val.list[0]" v-text="val.list[0]"></i>
                          <i v-else></i>
                        </td>
                        <td v-if="item.data.tier_variations.length > 1">
                          <i v-if="val.list[1]" v-text="val.list[1]"></i>
                          <i v-else></i>
                        </td>
                        <td><input class="table-input" v-model="val.name"></td>
                        <td><input class="table-input" v-on:change="InputDetection('price',pindex,2,ix)" :class="{'redborder':!val.price || val.price == 0}" v-model="val.price"></td>
                        <td><input class="table-input" v-model="val.weight" v-on:change="InputDetection('weight',pindex,2,ix)"></td>
                        <td><input class="table-input" v-model="val.stock" v-on:change="InputDetection('stock',pindex,2,ix)"></td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td><input class="table-input" :class="{'redborder':!item.data.price || item.data.price == 0}"
                            v-model="item.data.price" v-on:change="InputDetection('price',pindex,1)"></td>
                        <td><input class="table-input" v-model="item.data.stock" v-on:change="InputDetection('stock',pindex,1)"></td>
                      </tr>
                    </tbody>
                  </table>

                </td>
                <td class="btn-arr">
                  <button class="layui-btn" v-on:click="ReductionItem(pindex,4)">还原</button>
                  <button v-if="pricing_type != 3" class="layui-btn layui-btn-warm" v-on:click="CountPrice(item.data,pindex)">定价</button>
                  <button class="layui-btn layui-btn-normal" v-on:click="Origin(item.origin)">来源</button>
                  <button class="layui-btn layui-btn-danger" v-on:click="RemoveItem(pindex)">移除</button>
                </td>
              </tr>

            </tbody>
          </table>
        </section>
        <!-- 折扣&定价 -->


        <!-- 物流信息 -->
        <section v-if="navList[5].active">
          <table class="layui-table" v-for="(item,pindex) in list">
            <thead>
              <tr>
                <th class="list-index">编号</th>
                <th class="img-width">图片</th>
                <th>预售（{{item.data.name}}）</th>
                <th>包裹尺寸</th>
                <th class="btnArr-width">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-text="pindex+1"></td>
                <td v-viewer>
                  <img class="table_img" :src="$picture(item.image)">
                </td>
                <td>
                  <div class="col-row layui-form marginTop">
                    <div class="layui-input-inline" id="Pre-sale">
                      <input type="radio" :name="'Pre-sale'+pindex" value="false" title="否" lay-filter="Pre-sale"
                        :data-pindex="pindex" :checked="!item.data.is_pre_sale">
                      <input type="radio" :name="'Pre-sale'+pindex" value="true" title="是" lay-filter="Pre-sale"
                        :data-pindex="pindex" :checked="item.data.is_pre_sale">
                    </div>
                    <div class="col-log-hint" style="line-height: 27px;" v-if="!item.data.is_pre_sale">我将在2天内发货（不包括公共假期和快递服务休息日）。</div>
                    <div class="col-log-hint" v-else>
                      <a>我需要</a>
                      <a><input max="10" min="5" type="txt" v-on:change="SaleDay(pindex)" v-model="item.data.pre_sale" /></a>
                      <a>出货天数（您可以填写5至10）</a>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="col-row BagSize">
                    <div class="marginTop BagSizeRow">
                      <input class="col-right-form" v-model="item.data.baglength" placeholder="长" v-on:change="InputDetection('baglength',pindex,1)" /><a class="col-right-unit">cm</a>
                    </div>
                    <div class="BagSizeRow">
                      <input class="col-right-form" v-model="item.data.bagwidth" placeholder="宽" v-on:change="InputDetection('bagwidth',pindex,1)" /><a class="col-right-unit">cm</a>
                    </div>
                    <div class="BagSizeRow">
                      <input class="col-right-form" v-model="item.data.bagheight" placeholder="高" v-on:change="InputDetection('bagheight',pindex,1)" /><a class="col-right-unit">cm</a>
                    </div>
                  </div>
                </td>
                <td class="btn-arr">
                  <button class="layui-btn" v-on:click="ReductionItem(pindex,5)">还原</button>
                  <button class="layui-btn layui-btn-normal" v-on:click="Origin(item.origin)">来源</button>
                  <button class="layui-btn layui-btn-danger" v-on:click="RemoveItem(pindex)">移除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <!-- 物流信息 -->

        <!-- 发布设置 -->
        <section v-if="navList[6].active">
          <table class="layui-table" v-for="(item,pindex) in list">
            <thead>
              <tr>
                <th class="list-index">编号</th>
                <th class="img-width">图片</th>
                <th>上架设置（{{item.data.name}}）</th>
                <th class="btnArr-width">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-text="pindex+1"></td>
                <td v-viewer>
                  <img class="table_img" :src="$picture(item.image)">
                </td>
                <td>
                  <div class="col-row Nopadding NoMarginTop">
                    <div class="col-left"><a>上架设置</a></div>
                    <div class="col-right layui-form">
                      <div class="layui-input-inline">
                        <input type="radio" :name="'is_listed'+pindex" value="true" title="立即上架" lay-filter="is_listed" :data-pix="pindex" :checked="item.data.is_listed">
                        <input type="radio" :name="'is_listed'+pindex" value="false" title="暂不上架" lay-filter="is_listed" :data-pix="pindex" :checked="!item.data.is_listed">
                      </div>
                    </div>
                  </div>
                  <div class="col-row Nopadding NoMarginTop">
                    <div class="col-left"><a>SKU原价</a></div>
                    <div class="col-right layui-form">
                      <div class="layui-input-inline">
                        <input type="radio" :name="'skuprice'+pindex" value="true" title="是" lay-filter="skuprice" :data-pix="pindex" :checked="item.data.skuprice">
                        <input type="radio" :name="'skuprice'+pindex" value="false" title="否" lay-filter="skuprice" :data-pix="pindex" :checked="!item.data.skuprice">
                      </div>
                    </div>
                  </div>
                </td>
                <td class="btn-arr">
                  <button class="layui-btn" v-on:click="ReductionItem(pindex,6)">还原</button>
                  <button class="layui-btn layui-btn-normal" v-on:click="Origin(item.origin)">来源</button>
                  <button class="layui-btn layui-btn-danger" v-on:click="RemoveItem(pindex)">移除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <!-- 发布设置 -->

      </div>

      <!-- 阴影样式 -->
      <div class="GradientBox"></div>

      <!-- 操作引导 -->
      <div class="GuideBox" v-on:click="CloseTips" v-if="isTips">
        <img class="GuideImg" v-if="isShow" src="../../../static/images/guide.png">
        <img class="GuideImg" v-else src="../../../static/images/guide_.png">
      </div>

    </div>

    <!-- 导航菜单 -->
    <div class="BulkNavList">
      <ul>
        <li v-for="(nav,index) in navList" :class="{'BulkNavActive':nav.active}" v-on:click="NavActive(index)">
          <i v-if="nav.active" class="BulkBTop"></i>
          <a v-text="nav.name"></a>
          <i v-if="nav.active" class="BulkBBottom"></i>
        </li>
      </ul>

      <div class="BulkNavBtn BtnList">
        <button class="layui-btn" v-on:click="AllApply" v-if="navix < 2 ||  navix > 4">批量应用</button>
        <button class="layui-btn" v-on:click="AllTranslation">翻译简体</button>
        <button class="layui-btn" v-on:click="SaveEdit(true)">另存为</button>
        <button class="layui-btn" v-on:click="SaveEdit(false)">保存</button>
        <button class="layui-btn" v-on:click="Release">发布</button>
        <button class="layui-btn" v-on:click="NavSwitch">
          <i v-if="isShow">折叠</i>
          <i v-else>展开</i>
          <i class="layui-icon layui-font-12" :class="{'layui-icon-down':isShow,'layui-icon-up':!isShow}"></i>
        </button>
        <button class="layui-btn layui-btn-danger" v-on:click="ClosePage">关闭</button>
      </div>
    </div>

    <!-- 底部 -->
    <div class="BulkBottomBox" id="BulkBottomBox">
      <div class="BulkBottom">
        <div class="BulkEditBox">
          <div class="BulkEdit">

            <!-- 店铺&类目 -->
            <section class="BulkEditNav">
              <div class="col-data">
                <div class="col-row marginTop" style="padding-right:30px;">
                  <div class="col-left"><a><i class="required">*</i>店铺选择(shop)</a></div>
                  <div class="col-right layui-form shop_select_box">
                    <select type="text" lay-filter="shop_select" autocomplete="off" class="layui-select shop_box shop-select"
                      lay-search>
                      <option v-for="shop in shops" :data-shop="JSON.stringify(shop)" v-text="shop.merchant_name"
                        :selected="shop.active"></option>
                    </select>
                  </div>
                </div>
                <div class="col-row BulkEditTop">
                  <div class="col-left"><a><i class="required">*</i>商品分类(classify)</a></div>
                  <div class="col-right layui-form">
                    <button class="layui-btn layui-btn-primary" type="button" lay-submit v-on:click="ShowClassify('all')">选择分类</button>
                    <a class="col-classify" v-if="common.categories.length > 0">
                      <a v-for="(classify,index) in common.categories">
                        <i v-text="classify.display_name_zh+'「'+classify.display_name+'」'"></i><i v-if="index != (common.categories.length-1)"
                          v-text="' > '"></i>
                      </a>
                      <a class="redColor">
                        <i v-if="common.isSpecial == 0">（普货）</i>
                        <i v-if="common.isSpecial == 1">（特货）</i>
                      </a>
                      <a class="col-classify-used-set" v-on:click="SetUsedClassify">设为常用</a>
                    </a>
                    <a v-else class="col-classify redtxt">
                      *请选择分类
                    </a>
                    <a class="col-classify-used" v-on:click="ShowUsedClassify('all')"><i class="fa fa-book" ></i> 常用分类</a>
                  </div>
                </div>
              </div>

              <div class="col-data">
                <div class="col-data-left" v-for="(attr,index) in common.attributes">
                  <div class="col-row col-classify-row">
                    <div class="col-left tipsBox" :class="'tipsall'+index" data-pix="all" :data-ix="index">
                      <a>
                        <i class="col-left-data" v-if="attr.display_attribute_name"><span class="required" v-if="attr.is_mandatory">*</span>{{attr.display_attribute_name}}({{attr.original_attribute_name}})</i>
                        <i class="col-left-data" v-else><span class="required" v-if="attr.is_mandatory">*</span>{{attr.original_attribute_name}}</i>
                      </a>
                    </div>

                    <!-- 输入框 -->
                    <div class="col-right layui-form col-right-select" v-if="attr.input_type == 'TEXT_FILED'">
                      <input type="text" v-model="attr.current_select_en" class="input-box layui-input" placeholder="在此输入内容"
                        autocomplete="off">

                        <select type="text" lay-filter="unit_select_box" autocomplete="off" class="layui-select" lay-search v-if="attr.attribute_unit.length > 0">
                          <option v-for="(unit,ix) in attr.attribute_unit" :data-ix="index" :data-six="ix" data-pindex="all" v-text="unit"></option>
                        </select>
                    </div>

                    <!-- 下拉框 -->
                    <div class="col-right layui-form" v-else>
                      <select type="text" lay-filter="select_box" autocomplete="off" class="layui-select" lay-search>
                        <option v-if="!attr.current_select_en"></option>
                        <option v-for="(option,ix) in attr.attribute_value_list" v-text="option.original_value_name+'('+option.display_value_name+')'"
                          :data-name="option.original_value_name" :data-aid="option.value_id" :data-ix="index"
                          :data-six="ix" data-pindex="all" :selected="option.original_value_name == attr.current_select_en"></option>
                      </select>
                    </div>

                  </div>
                </div>
              </div>

            </section>
            <!-- 店铺&类目 -->

            <!-- 基本信息 -->
            <section class="BulkEditNav">
              <div class="col-row marginTop Nopadding" style="position: relative;">
                <div class="col-left"><a>商品标题</a></div>
                <div class="col-right">
                  <input class="col-right-form" style="padding-right: 100px;width: calc(100% - 115px);" :class="{'redborder':common.titleHint}" v-on:input="TitleCheck('all',1)" v-on:focus="TitleCheckStart(1)" v-on:blur="TitleCheckEnd(1)" v-model="common.name" placeholder="请输入标题" />
                  <a class="WordLimit" v-if="common.name">
                    <i v-text="common.namelength"></i>
                    /
                    <i>180</i>
                  </a>
                </div>
                <!-- 标题提示 -->
                <div class="title-hint" v-if="common.titleHint" style="top:-10px;">
                  <i v-text="common.titleHintTxt"></i>
                  <i class="layui-icon title-hint-icon"></i>
                </div>
              </div>
              <div class="col-row BulkEditTop Nopadding">
                <div class="col-left"><a>标题设置</a></div>
                <div class="col-right" style="width: calc(50% - 65px);">
                  <input class="col-right-form" v-model="common.prefix" placeholder="标题前缀" />
                </div>
                <div class="col-right" style="width: calc(50% - 65px);">
                  <input class="col-right-form" v-model="common.suffix" placeholder="标题后缀" />
                </div>
              </div>
              <div class="col-row BulkEditTop Nopadding">
                <div class="col-left"><a>标题替换</a></div>
                <div class="col-right" style="width: calc(50% - 65px);">
                  <input class="col-right-form" v-model="common.search_name" placeholder="替换前" />
                </div>
                <div class="col-right" style="width: calc(50% - 65px);">
                  <input class="col-right-form" v-model="common.replace_name" placeholder="替换后" />
                </div>
              </div>
              <div class="col-row BulkEditTop Nopadding">
                <div class="col-left"><a>商品货号</a></div>
                <div class="col-right">
                  <input class="col-right-form" placeholder="自定义商品货号" v-model="common.ProductCode" />
                </div>
              </div>
              <div class="col-row BulkEditTop Nopadding" style="position: relative;">
                <div class="col-left"><a>商品描述</a></div>
                <div class="col-right">
                  <textarea
                   :class="{'redborder':common.desHint}" v-model="common.description" v-on:input="TitleCheck('all',2)" v-on:focus="TitleCheckStart(2)" v-on:blur="TitleCheckEnd(2)" class="col-right-form textarea-des"></textarea>
                    <a class="WordLimit" v-if="common.description">
                      <i v-text="common.deslength"></i>
                      /
                      <i>5000</i>
                    </a>
                </div>
                <!-- 描述提示 -->
                <div class="title-hint" v-if="common.desHint" style="top:-10px;">
                  <i v-text="common.desHintTxt"></i>
                  <i class="layui-icon title-hint-icon"></i>
                </div>
              </div>
              <div class="col-row BulkEditTop Nopadding">
                <div class="col-left"><a>描述插入</a></div>
                <div class="col-right" style="width: calc(50% - 65px);">
                  <textarea style="resize:vertical;padding:15px;overscroll-behavior: auto contain;height: 50px;"
                    v-model="common.start_description" placeholder="描述前缀插入" class="col-right-form"></textarea>
                </div>
                <div class="col-right" style="width: calc(50% - 65px);">
                  <textarea style="resize:vertical;padding:15px;overscroll-behavior: auto contain;height: 50px;"
                    v-model="common.end_description" placeholder="描述后缀插入" class="col-right-form"></textarea>
                </div>
              </div>
              <div class="col-row BulkEditTop Nopadding">
                <div class="col-left"><a>描述替换</a></div>
                <div class="col-right" style="width: calc(50% - 65px);">
                  <textarea style="resize:vertical;padding:15px;overscroll-behavior: auto contain;height: 50px;"
                    v-model="common.search_description" placeholder="查询描述内容" class="col-right-form"></textarea>
                </div>
                <div class="col-right" style="width: calc(50% - 65px);">
                  <textarea style="resize:vertical;padding:15px;overscroll-behavior: auto contain;height: 50px;"
                    v-model="common.replace_description" placeholder="替换为当前数据" class="col-right-form"></textarea>
                </div>
              </div>
            </section>
            <!-- 基本信息 -->

            <!-- 图片 -->
            <section class="BulkEditNav">
              <div class="layui-form">
                <a class="all-img" :class="{'all-img-active':common.allImg}" style="padding-right:0;">
                  <input type="checkbox" name="allimg" data-etype="1" lay-filter="CommonAllImg" lay-skin="primary" title="全选" :checked="common.allImg">
                </a>
                <a class="all-img" :class="{'all-img-active':common.allMainImg}" style="padding-right:0;">
                  <input type="checkbox" name="allimg" data-etype="2" lay-filter="CommonAllImg" lay-skin="primary" title="全选主图" :checked="common.allMainImg">
                </a>
                <a class="all-img" v-on:click="AllOperateImg(1)">保留选中</a>
                <a class="all-img" v-on:click="AllOperateImg(2)">删除选中</a>
                <a class="all-img" v-on:click="ShowWaterPrint('all')">全部添加水印</a>
                <a class="all-img" v-on:click="AllRestorePicture">全部恢复图片</a>
                <a class="all-img" v-on:click="AllKeepPicture">全部保留前9张</a>
              </div>
              <div class="col-row BulkEditTop Nopadding">
                <div class="col-left" style="text-align:left;width:60px;"><a>图片设置</a></div>
                <div class="col-right" style="width: calc(20% - 65px);">
                  <input class="layui-select" v-model="common.setmp" placeholder="将第 X 张设为主图" />
                </div>
                <div class="col-right" style="width: calc(20% - 65px);">
                  <input class="layui-select" v-model="common.delfp" placeholder="删除第 X 张之前图片" />
                </div>
                <div class="col-right" style="width: calc(20% - 65px);">
                  <input class="layui-select" v-model="common.dellp" placeholder="删除第 X 张之后图片" />
                </div>
                <div class="col-right" style="width: calc(20% - 65px);">
                  <input class="layui-select" v-model="common.first" placeholder="删除第 X" />
                </div>
                <div class="col-right" style="width: 10px;line-height: 38px;">至</div>
                <div class="col-right" style="width: calc(20% - 65px);">
                  <input class="layui-select" v-model="common.last" placeholder="X 张图片" />
                </div>
                <div class="col-right" style="width: 100px;">
                  <div class="col-row marginTop Nopadding">
                    <button class="layui-btn" type="button" lay-submit v-on:click="AllImagesChange(1)">批量应用</button>
                  </div>
                </div>
              </div>
              <div class="col-row BulkEditTop Nopadding">
                <div class="col-left" style="text-align:left;width:60px;"><a>图片添加</a></div>
                <div class="col-right" style="width: 135px;">
                  <div v-if="common.image" class="col-img layui-form" :style="{'background-image': 'url('+common.image+')'}">
                    <img :src="common.image" style="opacity:0;">
                    <a class="col-select-box NoSelect" data-etype="pro" data-pindex="all" data-imgindex="'all'"></a>
                    <p class="col-imglist-btn" v-if="common.image">
                      <a class="col-imglist-btn-a" v-on:click="beautifyImg('pro','all','all',common.image)"><i class="fa fa-pencil-square-o"></i> 美化</a>
                      <a class="col-imglist-btn-a" v-on:click="deletefile('all')"><i class="fa fa-trash-o"></i> 删除</a>
                    </p>
                  </div>
                  <p v-else class="col-img">
                    <a class="col-img-btn" v-on:click="PictureSelection('all','pro','空间图片')"><i class="layui-icon">&#xe624;</i>
                      空间图片</a>
                    <a class="col-img-btn" v-on:click="WebPicture('all','pro')"><i class="layui-icon">&#xe624;</i>
                      网络图片</a>
                    <a class="col-img-btn">
                      <i class="layui-icon">&#xe624;</i> 本地上传
                      <input accept="image/*" class="addimginput upload_img" data-te="pro" data-pindex="all"
                        multiple type="file" name="img">
                    </a>
                  </p>
                </div>
                <div class="col-right layui-form" style="width: calc(33% - 80px);">
                  <select type="text" id="imgix" autocomplete="off" class="layui-select shop-select">
                    <option :value="item" v-for="item in 8">设置为 第{{item}}张图片</option>
                  </select>
                </div>
                <div class="col-right" style="width: 100px;">
                  <div class="col-row marginTop Nopadding">
                    <button class="layui-btn" type="button" lay-submit v-on:click="AllImagesChange(2)">批量应用</button>
                  </div>
                </div>
              </div>
            </section>
            <!-- 图片 -->

            <!-- SKU -->
            <section class="BulkEditNav">
              <div class="layui-form">
                <a class="all-img" v-on:click="ReductionSku">还原全部</a>
                <a class="all-img" v-on:click="AllUnitConversion">全部斤转换kg</a>
                <a class="all-img" v-on:click="AllAutoSku">全部自动保留50个SKU</a>
                <a class="all-img" v-on:click="AllAutoSkuLen">全部自动删减SKU长度</a>
                <a class="all-img" v-on:click="ShowUsedSku('all')">全部SKU设置</a>
                <a class="all-img sku-replace" data-six="all">全部SKU关键词替换</a>
              </div>
            </section>
            <!-- SKU -->

            <!-- 自动定价 -->
            <section class="BulkEditNav" style="min-height: 250px;">
              <div class="col-data">
                <div class="col-data-left" style="width: calc(50% - 85px);height: auto;">
                  <div class="col-row Nopadding" style="padding-right:20px !important;">
                    <div class="col-left"><a>销售价</a></div>
                    <div class="col-right">
                      <input class="layui-input" placeholder="不填为默认价格" v-model="common.price" />
                    </div>
                  </div>
                </div>
                <div class="col-data-left layui-form" style="width: 110px;height: auto;">
                  <div class="col-row Nopadding" style="padding-right:20px !important;">
                    <div class="col-right" style="width:100%;margin-left: 0;">
                      <select type="text" id="operator" autocomplete="off" class="layui-select shop-select">
                        <option value="+">加(+)</option>
                        <option value="-">减(-)</option>
                        <option value="*">乘(*)</option>
                        <option value="/">除(/)</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-data-left" style="width: calc(50% - 235px);height: auto;">
                  <div class="col-row Nopadding" style="padding-right:20px !important;">
                    <div class="col-right" style="width:100%;margin-left: 0;">
                      <input class="layui-input" v-model="common.priceCal" />
                    </div>
                  </div>
                </div>
                <div class="col-data-left" style="width: 210px;height: auto;">
                  <div class="col-row" style="padding-left: 0;">
                    <button class="layui-btn" style="margin-right: 5px;" type="button" lay-submit v-on:click="AllChangePrice">批量应用</button>
                    <button class="layui-btn layui-btn-primary" type="button" lay-submit v-on:click="RecoverPrice">恢复价格</button>
                  </div>
                </div>
              </div>
              <div class="col-data" v-if="pricing.length > 0">

                <div class="col-data-left" style="width: calc(50% - 105px);height: auto;">
                  <div class="col-row Nopadding">
                    <div class="col-left"><a><i class="required">*</i>定价模板</a></div>
                    <div class="col-right layui-form">
                      <select type="text" lay-filter="pricing_select" autocomplete="off" class="layui-select">
                        <option v-for="(pobj,index) in pricing" :data-id="pobj.id" v-text="pobj.name" :data-ix="index"
                          :selected="pobj.is_select == 1"></option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-data-left" style="width: calc(50% - 105px);height: auto;">
                  <div class="col-row">
                    <div class="col-left"><a><i class="required">*</i>包裹重量</a></div>
                    <div class="col-right">
                      <input class="layui-input" v-model="common.weight" placeholder="输入重量" v-on:change="InputDetection('weight')"/>
                      <a class="col-right-unit">g</a>
                    </div>
                  </div>
                </div>
                <div class="col-data-left" style="width: 210px;height: auto;" v-if="pricing_type != 3">
                  <div class="col-row" style="padding-left: 0;">
                    <button class="layui-btn" style="margin-right: 5px;" type="button" lay-submit v-on:click="AllCountPrice">自动定价</button>
                    <button class="layui-btn layui-btn-primary" type="button" lay-submit v-on:click="RecoverPrice">恢复价格</button>
                  </div>
                </div>
              </div>
              <div class="col-data" v-else>
                <div class="col-data-left" style="width: calc(39% - 90px);height: auto;">
                  <div class="col-row Nopadding">
                    <div class="col-left"><a><i class="required">*</i>定价模板</a></div>
                    <div class="col-right layui-form">
                      <select type="text" lay-filter="pricing_select" autocomplete="off" class="layui-select">
                        <option v-for="(pobj,index) in pricing" :data-id="pobj.id" v-text="pobj.name" :data-ix="index"
                          :selected="pobj.is_select == 1"></option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-data-left" style="width: 70px;margin-left: 18px;height: auto;">
                  <div class="Refreshpricing" v-on:click="get_pricing"><i class="fa fa-refresh"></i> 刷新</div>
                </div>
                <div class="col-data-left" style="width: 39%;height: auto;">
                  <div class="col-row">
                    <div class="col-left"><a><i class="required">*</i>商品重量</a></div>
                    <div class="col-right">
                      <input class="col-right-form" v-model="common.weight" placeholder="输入重量" v-on:change="InputDetection('weight')"/>
                      <a class="col-right-unit">g</a>
                    </div>
                  </div>
                </div>
                <div class="col-data-left" style="width: 10%;height: auto;">
                  <div class="col-row" style="padding-left: 0;">
                    <button class="layui-btn" type="button" lay-submit v-on:click="OpenPage('Pricing')">添加自动定价模板</button>
                  </div>
                </div>
              </div>
              <div class="edit-hint" style="margin-left: 25px;" v-if="pricing_type == 3">提示：订单利润无需点击自动定价，发布到店铺的时候，系统会根据定价模板自动计算出商品销售价、促销价</div>
              <div class="edit-hint" style="margin-left: 25px;" v-else>提示：点击自动定价按钮，系统会拉取采集的商品价格 根据定价模板自动计算出商品销售价、促销价</div>
            </section>
            <!-- 自动定价 -->

            <!-- 物流信息 -->
            <section class="BulkEditNav">
              <div class="col-row marginTop Nopadding">
                <div class="col-left"><a><i class="required">*</i>是否预售</a></div>
                <div class="col-right layui-form">
                  <div class="layui-input-inline" id="Pre-sale">
                    <input type="radio" name="Pre-sale" value="false" title="否" lay-filter="Pre-sale" data-pindex="all"
                      :checked="!common.is_pre_sale">
                    <input type="radio" name="Pre-sale" value="true" title="是" lay-filter="Pre-sale" data-pindex="all"
                      :checked="common.is_pre_sale">
                  </div>
                </div>
                <div class="col-right">
                  <div class="col-log-hint" style="line-height: 27px;" v-if="!common.is_pre_sale">我将在3天内发货（不包括公共假期和快递服务休息日）。</div>
                  <div class="col-log-hint" v-else>
                    <a>我需要</a>
                    <a><input max="10" min="5" type="txt" v-on:change="SaleDay('all')" v-model="common.pre_sale" /></a>
                    <a>出货天数（您可以填写5至10）</a>
                  </div>
                </div>
              </div>
              <div class="col-row BulkEditTop Nopadding">
                <div class="col-left"><a><i class="required">*</i>包裹尺寸</a></div>
                <div class="col-right">
                  <div class="col-right-inputs col-right-three"><input class="col-right-form" v-model="common.baglength"
                      placeholder="长" v-on:change="InputDetection('baglength')"/><a class="col-right-unit">cm</a></div>
                  <div class="col-right-inputs col-right-three"><input class="col-right-form" v-model="common.bagwidth"
                      placeholder="宽" v-on:change="InputDetection('bagwidth')"/><a class="col-right-unit">cm</a></div>
                  <div class="col-right-inputs col-right-three"><input class="col-right-form" v-model="common.bagheight"
                      placeholder="高" v-on:change="InputDetection('bagheight')"/><a class="col-right-unit">cm</a></div>
                </div>
              </div>
            </section>
            <!-- 物流信息 -->

            <!-- 发布设置 -->
            <section class="BulkEditNav">
              <div class="col-row marginTop Nopadding">
                <div class="col-left"><a>发布时间</a></div>
                <div class="col-right layui-form">
                  <div class="layui-input-inline">
                    <input type="radio" name="publish_now" value="true" title="立即发布" lay-filter="publish_now" data-pix="all" :checked="common.publish_now">
                    <input type="radio" name="publish_now" value="false" title="定时发布" lay-filter="publish_now" data-pix="all" :checked="!common.publish_now">
                  </div>
                </div>
              </div>
              <div class="col-row Nopadding" v-if="!common.publish_now">
                <div class="col-left"><a><i class="required">*</i>时间设置</a></div>
                <div class="col-right">
                  <div class="col-right-inputs col-right-three">
                    <input type="text" lay-verify="required" class="layui-input" id="publish_date" v-model="common.publish_date" placeholder="发布开始时间" autocomplete="off">
                  </div>
                  <div class="col-right-inputs col-right-three">
                    <input class="layui-input" placeholder="发布频率" id="publish_rate" v-model="common.publish_rate" v-on:change="InputDetection('publish_rate')"/>
                    <a class="col-right-unit">分钟</a>
                  </div>
                </div>
              </div>
              <div class="col-row Nopadding">
                <div class="col-left"><a>上架设置</a></div>
                <div class="col-right layui-form">
                  <div class="layui-input-inline">
                    <input type="radio" name="is_listed" value="true" title="立即上架" lay-filter="is_listed" data-pix="all" :checked="common.is_listed">
                    <input type="radio" name="is_listed" value="false" title="暂不上架" lay-filter="is_listed" data-pix="all" :checked="!common.is_listed">
                  </div>
                </div>
              </div>
              <div class="col-row Nopadding">
                <div class="col-left"><a>SKU原价</a></div>
                <div class="col-right layui-form">
                  <div class="layui-input-inline">
                    <input type="radio" name="skuprice" value="true" title="是" lay-filter="skuprice" data-pix="all" :checked="common.skuprice">
                    <input type="radio" name="skuprice" value="false" title="否" lay-filter="skuprice" data-pix="all" :checked="!common.skuprice">
                    <i class="layui-form-hint">（是否自动将商品原价添加至SKU规格中）</i>
                  </div>
                </div>
              </div>
            </section>
            <!-- 发布设置 -->

          </div>
        </div>

      </div>

      <!-- 测量box高度 -->
      <div class="boxheight"></div>

    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
  var self, form, layer, slider, laypage, laydate, dropdown, skuinfo,xmlModule,xmlTwoModule,xmlThreeModule,sliderVal=1,isSlider,WatermarkList,picix,Spaceimgs=[],
  allType,editType,editor;
  import axios from 'axios'
  import draggable from 'vuedraggable'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  import * as gaoding from '@gaoding/editor-sdk';
  import MTImageEditor from "mt-image-editor-sdk";
  export default {
    name: 'BulkGlobal',
    components: {
      draggable,
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        isLoding: true,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        uid: null,
        te: null, //区分采集列表或发布列表
        ids: [],
        pix: null,
        navix: 0,
        navList: [{
          active: true,
          name: "店铺&类目"
        }, {
          active: false,
          name: "基本信息"
        }, {
          active: false,
          name: "图片"
        }, {
          active: false,
          name: "SKU"
        }, {
          active: false,
          name: "自动定价"
        }, {
          active: false,
          name: "物流信息"
        }, {
          active: false,
          name: "发布设置"
        }],
        list: [],
        shops: [],
        shop: null,
        CurrentClassify: null,
        categories: [],
        categorieslist: [],
        pricing: [],
        pricing_type:1,
        common: {
          allImg: false,
          allMainImg: false,
          image:null,
          name:null,
          namelength:null,
          deslength:null,
          CurrentClassify: null,
          categories: [],
          categorieslist: [],
          attributes: [],
          is_pre_sale: false,
          pre_sale: null,
          limit: 0,
          weight: null,
          baglength: null,
          bagwidth: null,
          bagheight: null,
          titleHint:null,
          titleHintTxt:null,
          desHint:null,
          desHintTxt:null,
          publish_now:true,
          is_listed:true
        },
        isShow: true,
        isTips: true,
        isClick: false,
        TranslationList: this.LanguageList(),
        WatermarkID:null,
        etype:null,
        Spaceimgs:[],
        MeiTuParams: {}, //当前选中图片参数
      }
    },
    updated() {
      if (form) {
        form.render();
      }
    },
    mounted() {
      self = this;
      self.uid = localStorage.getItem("ExShopee_id");

      if (localStorage.getItem("ExShopee_EditType")) {
        self.te = localStorage.getItem("ExShopee_EditType");
      }

      if (localStorage.getItem("ExShopee_isTips")) {
        self.isTips = false;
      }

      //包裹尺码
      if (!self.empty(localStorage.getItem("ExShopee_baglength"))) {
        self.common.baglength = localStorage.getItem("ExShopee_baglength");
      }else{
        self.common.baglength = 5
      }
      if (!self.empty(localStorage.getItem("ExShopee_bagwidth"))) {
        self.common.bagwidth = localStorage.getItem("ExShopee_bagwidth");
      }else{
        self.common.bagwidth = 5
      }
      if (!self.empty(localStorage.getItem("ExShopee_bagheight"))) {
        self.common.bagheight = localStorage.getItem("ExShopee_bagheight");
      }else{
        self.common.bagheight = 5
      }

      //屏幕宽度改变
      self.GetSize();
      window.addEventListener('resize', function() {
        if(self.$route.name == "BulkGlobal"){
          self.GetSize();
        }
      })

      //图片美化
      editor = gaoding.createImageEditor({
          appId: 'HCEZVL492117',
      });

      layui.use(['form', 'layer','slider', 'laypage', 'laydate', 'dropdown'], function() {
        form = layui.form;
        layer = layui.layer;
        slider = layui.slider;
        laypage = layui.laypage;
        laydate = layui.laydate;
        dropdown = layui.dropdown;
        form.render();

        if (localStorage.getItem("ExShopee_EditIds")) {
          var ids = JSON.parse(localStorage.getItem("ExShopee_EditIds"));
          if (ids.length > 0) {
            self.ids = ids;
            self.get_shop_list(); //加载店铺
          }
        }

        //店铺选择-下拉
        form.on('select(shop_select)', function(data) {
          var shop = JSON.parse(data.elem[data.elem.selectedIndex].dataset.shop);
          self.shop = shop;
        });

        //选择分类
        $("#main-box").on('click', '.ClassifyMainRow', function() {
          var top = $(this).parent().scrollTop();
          var id = $(this).attr("data-id");
          var name = $(this).attr("data-name");
          var name_zh = $(this).attr("data-name_zh");
          var NoChildren = $(this).attr("data-children");
          var ctype = $(this).attr("data-ctype");
          var ix = $(this).attr("data-ix");
          var six = $(this).attr("data-six");
          // console.log(ix)
          // console.log(id)
          // console.log(NoChildren);

          //清除选中
          for (let i in self.categorieslist[ix]) {
            self.categorieslist[ix][i].istrue = false;
          }
          self.categorieslist[ix][six].istrue = true;
          self.categories.splice(ix, self.categories.length)
          self.categories[ix] = {
            catid: id,
            display_name: name,
            display_name_zh: name_zh,
            top: top,
            category_type:ctype
          }; //当前点击
          self.CurrentClassify = id; //当前ID
          self.get_categories(false, ix, id);

          if (NoChildren == "True") {
            $('.classifybtn').addClass("layui-btn-disabled").attr("disabled", true);
          } else {
            $('.classifybtn').removeClass("layui-btn-disabled").attr("disabled", false);
          }
        })

        //分类确定
        form.on('submit(classifybtn)', function(data) {
          if (self.pix == "all") {
            self.common.categories = JSON.parse(JSON.stringify(self.categories));
            self.common.isSpecial = self.categories[self.categories.length-1].category_type;
          } else {
            self.list[self.pix].data.categories = JSON.parse(JSON.stringify(self.categories));
            self.list[self.pix].data.isSpecial = self.categories[self.categories.length-1].category_type;
          }
          self.get_attributes(self.CurrentClassify);
          return false;
        });

        //属性选择
        form.on('select(select_box)', function(data) {
          var txt = data.elem[data.elem.selectedIndex].text;
          var ix = data.elem[data.elem.selectedIndex].dataset.ix;
          var pix = data.elem[data.elem.selectedIndex].dataset.pindex;
          var name = data.elem[data.elem.selectedIndex].dataset.name;
          var aid = data.elem[data.elem.selectedIndex].dataset.aid;

          var attributes;
          if (pix == "all") {
            attributes = self.common.attributes[ix];
            attributes.current_select = txt;
            attributes.current_select_en = name;
            attributes.current_select_id = aid;
          } else {
            attributes = self.list[pix].data.attributes[ix];
            attributes.current_select = txt;
            attributes.current_select_en = name;
            attributes.current_select_id = aid;
          }

          //单位填充
          if(attributes.attribute_value_list.length > 0){
            for(let x in attributes.attribute_value_list){
              if(attributes.current_select_id == attributes.attribute_value_list[x].value_id){
                attributes.current_select_value_unit = attributes.attribute_value_list[x].value_unit;
              }
            }
          }

          self.$forceUpdate();
        });

        //单位选择
        form.on('select(unit_select_box)', function(data) {
          var ix = data.elem[data.elem.selectedIndex].dataset.ix;
          var pix = data.elem[data.elem.selectedIndex].dataset.pindex;
          if (pix == "all") {
            self.common.attributes[ix].current_select_value_unit = data.value;
          } else {
            self.list[pix].data.attributes[ix].current_select_value_unit = data.value;
          }

          self.$forceUpdate();
        });

        //图片选中
        $("#main-box").on("click", '.col-select-box', function(e) {
          let etype = $(this).attr("data-etype");
          let pix = $(this).attr("data-pindex");
          let imgix = $(this).attr("data-imgindex");
          if(etype == "pro"){
            if (self.list[pix].data.images[imgix].isActive) {
              self.list[pix].data.images[imgix].isActive = false;
            } else {
              self.list[pix].data.images[imgix].isActive = true;
            }
          }else{
            if (self.list[pix].data.tier_variations[0].images[imgix].isActive) {
              self.list[pix].data.tier_variations[0].images[imgix].isActive = false;
            } else {
              self.list[pix].data.tier_variations[0].images[imgix].isActive = true;
            }
          }
        });

        //空间图片选中
        $("#main-box").on("click", '.space-select-box', function(e) {
          picix = $(this).attr("data-ix");
          var child = $(this).prev().find("input[type='checkbox']");
          var status = child[0].checked;
          if (status) {
            self.Spaceimgs.pop();
            child[0].checked = false;
            $(".PictureSpace").find("li:eq(" + picix + ")").removeClass("img-active").attr("data-active", false);
          } else {
            if (self.etype == "sku" && self.Spaceimgs.length >= 1) {
              layer.msg("SKU属性只能选择一张图片！");
              return false;
            }
            self.Spaceimgs.push(picix);
            child[0].checked = true;
            $(".PictureSpace").find("li:eq(" + picix + ")").addClass("img-active").attr("data-active", true);
          }
          form.render('checkbox');
        });

        //图片全选
        form.on('checkbox(allimg)', function(data) {
          let etype = data.elem.dataset.etype;
          let pix = data.elem.dataset.pindex;
          let status = data.elem.checked;
          if(etype == 'pro'){
            self.list[pix].data.allImg = status;
            for (let i in self.list[pix].data.images) {
              self.list[pix].data.images[i].isActive = status;
            }
          }else{
            self.list[pix].data.allSkuImg = status;
            for (let i in self.list[pix].data.tier_variations[0].images) {
              self.list[pix].data.tier_variations[0].images[i].isActive = status;
            }
          }
          self.$forceUpdate();
        });

        //图片全选
        form.on('checkbox(CommonAllImg)', function(data) {
          let etype = data.elem.dataset.etype;
          let status = data.elem.checked;
          if(etype == 1){
            self.common.allImg = status;
          }else{
            self.common.allMainImg = status;
          }
          for (let i in self.list) {
            if(etype == 1){
              self.list[i].data.allImg = status;
              for (let x in self.list[i].data.images) {
                self.list[i].data.images[x].isActive = status;
              }
            }else{
              self.list[i].data.allMainImg = status;
              self.list[i].data.images[0].isActive = status;
            }
          }
          form.render();
        });

        //图片上传
        $("#main-box").on("change", ".upload_img", function(event) {
          var _this = $(this);
          let te = $(this).attr("data-te");
          let ix = $(this).attr("data-ix");
          let pix = $(this).attr("data-pindex");
          var $file = event.currentTarget;
          var formData = new FormData();
          var file = $file.files;

          for (var i = 0; i < file.length; i++) {
            formData.append(file[i].name, file[i]);
          }

          self.loading = true;
          $.ajax({
            url: self.GetServerUrl() + "/update_file/",
            type: 'post',
            dataType: 'json',
            data: formData,
            contentType: false,
            processData: false,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            },
            success: function(res) {
              self.loading = false;
              if (res.code == 200) {
                _this.val(""); //清空图片选中
                let datas = res.datas;
                if (te == "sku") {
                  self.list[pix].data.tier_variations[0].images[ix].url = datas[0];
                } else if(te == "pro") {
                  if(pix == "all"){
                    self.common.image = datas[0];
                  }else{
                    for (let i in datas) {
                      self.list[pix].data.images.push({
                        isActive: false,
                        url: datas[i]
                      });
                    }
                  }
                }else if(te == "size"){
                  self.list[pix].data.size_chart_info.size_chart = datas[0];
                } else if(te == "waterprint"){
                  $("#WaterPImg").attr("src",datas[0]);
                  self.WaterPLocation();
                }
              }
              console.log(res);
            },
            error: function(error) {
              self.loading = false;
              self.ToastFun(2, error); //弹窗提醒
            }
          })
        })

        //预售选择
        form.on('radio(Pre-sale)', function(data) {
          let pix = data.elem.dataset.pindex;
          if (pix == "all") {
            self.common.pre_sale = 5;
            self.common.is_pre_sale = JSON.parse(data.value);
          } else {
            self.list[pix].data.pre_sale = 5;
            self.list[pix].data.is_pre_sale = JSON.parse(data.value);
          }
        });

        //定价模板选择
        form.on('select(pricing_select)', function(data) {
          var ix = data.elem[data.elem.selectedIndex].dataset.ix;
          for (let item in self.pricing) {
            self.pricing[item].is_select = 0;
          }
          self.pricing[ix].is_select = 1;
          self.pricing_type = self.pricing[ix].e_type;
        });

        //Sku类型切换
        form.on('radio(sku)', function(data) {
          let pix = data.elem.dataset.pindex;
          if(JSON.parse(data.value) == false){
            self.list[pix].data.tier_variations = [];
          }else{
            if(self.list_Backup[pix].data.tier_variations && self.list_Backup[pix].data.tier_variations[0].name){
              self.list[pix].data.tier_variations = JSON.parse(JSON.stringify(self.list_Backup[pix].data.tier_variations))
            }else{
              self.list[pix].data.tier_variations = [];
            }
          }
          self.list[pix].data.is_tier_variations = JSON.parse(data.value);
        });

        //发布类型
        form.on('radio(publish_now)', function(data) {
          let pix = data.elem.dataset.pix;
          self.common.publish_now = JSON.parse(data.value);
          self.$nextTick(() => {
            if(!JSON.parse(data.value)){
              laydate.render({
                elem: "#publish_date",
                type: 'datetime',
                min: 0,
                max: 15,
                trigger: 'click',
                done: function(value, date, endDate){
                  self.common.publish_date = value;
                }
              });
            }
            self.GetSize();
          });

        });

        //上架状态
        form.on('radio(is_listed)', function(data) {
          let pix = data.elem.dataset.pix;
          if(pix == "all"){
            self.common.is_listed = JSON.parse(data.value);
          }else{
            self.list[pix].data.is_listed = JSON.parse(data.value);
          }
        });

        //SKU原价
        form.on('radio(skuprice)', function(data) {
          let pix = data.elem.dataset.pix;
          if(pix == "all"){
            self.common.skuprice = JSON.parse(data.value);
          }else{
            self.list[pix].data.skuprice = JSON.parse(data.value);
          }
          localStorage.setItem("ExShopee_SkuPrice",data.value);
        });

        //添加属性
        var isDelete = false;
        $("#main-box").on("keydown", '.col-sku-input', function(e) {
          var pix = $(this).attr("data-pindex");
          var ix = $(this).attr("data-ix");
          var val = $(this).val();
          if (e.keyCode == 8 && self.empty(val) && !isDelete) {
            if (self.list[pix].data.tier_variations.length > 0 && self.list[pix].data.tier_variations[ix].options
              .length > 0) {
              isDelete = true;
              self.list[pix].data.tier_variations[ix].options.pop()
              self.list[pix].data.tier_variations[ix].images.pop({isActive: false,url: null})

              self.CreateSkuArr(pix, self.list[pix].data); //更新SKU表
              setTimeout(function() {
                isDelete = false;
              }, 200);
            }
          } else if (e.keyCode == 13) {
            if (self.empty(val)) {
              return;
            }

            for (let i in self.list[pix].data.tier_variations[ix].options) {
              if (self.list[pix].data.tier_variations[ix].options[i] == val) {
                layer.msg('该属性已存在，请勿重复添加！');
                return;
              }
            }

            self.list[pix].data.tier_variations[ix].options.push(val);
            if (ix == 0) {
              self.list[pix].data.tier_variations[ix].images.push({isActive: false,url: null});
            }
            $(this).val("");
            self.CreateSkuArr(pix, self.list[pix].data); //更新SKU表
          }
        });

        //SKU编辑
        $("#main-box").on('keydown', '.layui-layer-input', function(event) {
          if (event.keyCode == 13) {
            let text = event.target.value;
            if(editType == "all"){
              for (let i in self.list[self.pix].data.customize_tier_variations) {
                //价格、折扣只能为数字
                if(allType != 'name' && (isNaN(text) || text == " ")){
                  layer.msg("请输入纯数字！");
                  return;
                }
                if(!text && allType != "weight"){
                  return;
                }
                eval('self.list[self.pix].data.customize_tier_variations[i].'+allType+'= text');
              }
            }else{
              for (let i in self.list[self.pix].data.tier_variations[skuinfo.ix].options) {
                if (self.list[self.pix].data.tier_variations[skuinfo.ix].options[i] == text) {
                  layer.msg('该属性已存在，请勿重复添加！');
                  return;
                }
              }
              if(self.GetBytesLength(text) > 30){
                layer.msg('长度'+self.GetBytesLength(text)+'，字符长度不能超过30位！');
                return;
              }
              self.EditFun(self.pix,skuinfo.ix, skuinfo.six, text);
            }
            self.$forceUpdate();
            layer.closeAll();
          }
        });

        //SKU-关键词替换
        $("#main-box").on('click', '.sku-replace', function(event) {
          let pindex = $(this).attr("data-pix");
          let six = $(this).attr("data-six");
          layer.open({
            type: 1,
            offset: '100px',
            title: "SKU关键词替换",
            area: ['600px', '250px'],
            fixed: false, //不固定
            btn: ['确定替换'],
            // btn: ['店铺授权', '查看我的店铺类型'],
            content: SkuReplace,
            success: function() {
              form.render();
            },
            yes: function(index, layero) {
              var valb = $("#Before_replacement").val();
              var vala = $("#After_replacement").val();
              var text;
              if(six == "all"){
                for (let x in self.list){
                  for (let y in self.list[x].data.tier_variations) {
                    for (let i in self.list[x].data.tier_variations[y].options) {
                      text = self.list[x].data.tier_variations[y].options[i].replace(valb, vala);
                      if(self.GetBytesLength(text) > 30){
                        layer.msg('长度'+self.GetBytesLength(text)+'，字符长度不能超过30位！');
                        continue;
                      }
                      self.EditFun(x, y, i, text);
                      layer.close(index);
                    }
                  }
                }
              }else{
                for (let i in self.list[pindex].data.tier_variations[six].options) {
                  text = self.list[pindex].data.tier_variations[six].options[i].replace(valb, vala);
                  if(self.GetBytesLength(text) > 30){
                    layer.msg('长度'+self.GetBytesLength(text)+'，字符长度不能超过30位！');
                    continue;
                  }
                  self.EditFun(pindex, six, i, text);
                  layer.close(index);
                }
              }
            }
          });
        });

        //文字提示
        var tips;
        $("#main-box").on('mouseenter', '.tipsBox', function(event) {
          let pix = $(this).attr("data-pix");
          let ix = $(this).attr("data-ix");
          if (pix == "all") {
            let txt = self.common.attributes[ix].original_attribute_name;
            if (self.common.attributes[ix].display_attribute_name) {
              txt += "(" + self.common.attributes[ix].display_attribute_name + ")"
            }
            tips = layer.tips(txt, '.tipsall' + ix, {
              tips: 4,
              time: 999999
            });
          } else {
            let txt = self.list[pix].data.attributes[ix].original_attribute_name;
            if (self.list[pix].data.attributes[ix].display_attribute_name) {
              txt += "(" + self.list[pix].data.attributes[ix].display_attribute_name + ")"
            }
            tips = layer.tips(txt, '.tips' + pix + ix, {
              tips: 4,
              time: 999999
            });
          }
        });
        $("#main-box").on('mouseleave', '.tipsBox', function(event) {
          layer.close(tips);
        });

        //批量编辑提示
        $("#main-box").on('mouseenter', '.BulkEditTips', function(event) {
          let pix = $(this).attr("data-pix");
          let te = $(this).attr("data-te");
          tips = layer.tips("点击批量编辑", '.Tips_' + te + pix, {
            tips: 1,
            time: 999999
          });
        });
        $("#main-box").on('mouseleave', '.BulkEditTips', function(event) {
          layer.close(tips);
        });

        //批量编辑
        $("#main-box").on('click', '.BulkEditTips', function(event) {
          let pix = $(this).attr("data-pix");
          let te = $(this).attr("data-te");
          self.pix = pix;
          allType = te,editType = "all"; //回车触发类型
          layer.prompt({
            title: '批量编辑',
            formType: 3,
            yes:function(index,layero){
              var pass = layero.find(".layui-layer-input").val();
              for (let i in self.list[pix].data.customize_tier_variations) {
                //价格、折扣只能为数字
                if(te != 'name' && (isNaN(pass) || pass == " ")){
                  layer.msg("请输入纯数字！");
                  return;
                }
                if(!pass && te != "weight"){
                  return;
                }
                eval('self.list[pix].data.customize_tier_variations[i].'+te+'= pass');
              }
              layer.close(index);
              self.$forceUpdate();
            }
          });
        });

        $("#main-box").on('click', '.WatermarkListImage', function(event) {
          window.open($(this).attr("data-img"));
        });

        self.initMeiTu(); //初始化美图秀秀

        // 保存回调
        MTImageEditor.saveImage((base64,type,id)=>{
          // base64：图片数据
          // type：图片类型,jpg|png
          // id：作图记录id //可用于二次编辑
          var formData = new FormData();
          var fileimgs = self.dataURLtoBlob(base64, 'img'); //base64转文件
          if(fileimgs){
            formData.append(fileimgs.name, fileimgs);
            self.imgUpload(formData); //上传图片
          }
          MTImageEditor.close(); //关闭弹窗
        });

      });
    },
    methods: {
      initMeiTu(){
        MTImageEditor.init({
            moduleName:'image-editor-sdk',
            // 必填，到开放平台申请通过后才可用
            appKey:'Rm0lBG4JmGtc04CCCVA0yiHt79J22BPC',
            title: '美图秀秀',
            //默认以弹窗形式展现，指定el后嵌入到指定target
            el:'',
            // 初始打开的图片
            // 您使用的图片域名，须添加跨域支持 eg: access-control-allow-origin: *
            // imageSrc: '',
            //是否带有全屏功能
            fullscreen:true,
            // 窗体宽高是否跟随window.onresize变更
            resizeAble:true,
        });
        MTImageEditor.close();
      },
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {

        }
      },
      NavActive(ix) {
        self.navix = ix;
        for (let i in self.navList) {
          self.navList[i].active = false;
        }
        self.navList[ix].active = true;

        $(".BulkEditNav").each(function() {
          $(this).hide();
        })
        $(".BulkEditNav").eq(ix).show();
        self.GetSize();

        //下拉翻译
        if(ix == 2 || ix == 3){
          self.$nextTick(() => {
            dropdown.render({
              elem: '.translation-img'
              // ,trigger: 'hover'
              ,data: [{
                title: '阿里翻译（实时低至0.028/次）'
                ,child: self.LanguageList(1)
              },{
                title: '免费翻译（速度慢易失败）'
                ,child: self.LanguageList(0)
              }]
              ,click: function(obj){
                self.SelectLanguage(self.pix,obj.id,obj.type);
              }
            });
          });
        }
      },
      GetSize() {
        $("#BulkBottomBox").height("auto");
        var winHeight = document.documentElement.clientHeight;
        var bottomHeight = document.getElementById("BulkBottomBox").clientHeight;
        var topHeight = winHeight - bottomHeight;
        if(topHeight < 0){
          topHeight = 60;
          $("#BulkBottomBox").height(winHeight - 60);
        }
        if (topHeight >= winHeight) {
          topHeight = winHeight - 50;
        }

        $(".GradientBox").css({
          top: (topHeight - 5) + 'px'
        });
        $(".GuideImg").css({
          top: (topHeight - 150) + 'px'
        });
        $(".BulkNavList").css({
          top: topHeight + 'px'
        });

        $(".BulkTopBox").height(topHeight);
      },
      get_shop_list() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_merchant/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var datalist = datas.list;
            if (datalist.length > 0) {
              for (let item in datalist) {
                if(!datalist[item].merchant_name){
                  datalist[item].merchant_name = JSON.parse(JSON.stringify(datalist[item].name));
                }
                if (item == 0) {
                  datalist[item].isSelect = true;
                } else {
                  datalist[item].isSelect = false;
                }
              }
              self.shops = datalist;
              self.shop = datalist[0];

              self.get_product_list(); //加载产品列表
              self.get_pricing(); //定价表
            }
          });

        }).catch(function(error) {
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      get_product_list() {
        var _url = '/collection_list_by_id/'
        if (JSON.parse(self.te)) {
          _url = '/get_production_merchant_list_by_id/' //发布列表
        }

        self.loading = true;
        let param = new URLSearchParams()
        param.append('id', JSON.stringify(self.ids));
        axios({
          method: 'post',
          url: self.GetServerUrl() + _url,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var datalist = datas.list;

            if (datalist.length > 0) {

              for (let item in datalist) {

                //店铺匹配
                if(item == 0){
                  if(datalist[item].main_account_id){
                    for (let x in self.shops) {
                      if(datalist[item].main_account_id == self.shops[x].main_account_id){
                        self.shops[x].active = true;
                        self.shop = JSON.parse(JSON.stringify(self.shops[x]));
                      }
                    }
                  }else{
                    self.shops[0].active = true;
                    self.shop = self.shops[0];
                  }
                }

                //初始化
                datalist[item].data = JSON.parse(datalist[item].data);
                datalist[item].data.is_pre_sale = false;
                datalist[item].data.isClick = false;
                datalist[item].data.pre_sale = 3;
                if(!datalist[item].data.size_chart_info){
                  datalist[item].data.size_chart_info = {
                    size_chart: '',
                    size_chart_id: 0
                  }
                }
                if(self.empty(datalist[item].data.ProductCode)){
                  datalist[item].data.ProductCode = "HLKJ" + datalist[item].id;
                }
                if (!datalist[item].data.stock) {
                  datalist[item].data.stock = 99999
                }
                if (!datalist[item].data.hasOwnProperty("is_listed")) {
                  datalist[item].data.is_listed = true
                }

                //默认是否选中SKU原价
                if(!self.empty(localStorage.getItem("ExShopee_SkuPrice"))){
                  datalist[item].data.skuprice = true;
                }else{
                  datalist[item].data.skuprice = false;
                }

                //SKU原价删减，防止影响编辑
                if(datalist[item].data.is_skuprice){
                  datalist[item].data.is_skuprice = false;
                  for(let x in datalist[item].data.customize_tier_variations){
                    let name = datalist[item].data.customize_tier_variations[x].name;
                    let fix = name.indexOf("_");
                    if(fix != -1){
                      datalist[item].data.customize_tier_variations[x].name = name.substring(fix+1,name.length);
                    }
                  }
                }

                //图片列表
                if (datalist[item].data.images) {
                  self.webpFilter(datalist[item].data.images); //webp图片过滤
                  datalist[item].data.allImg = false; //初始化选中
                  for (var img in datalist[item].data.images) {
                    if (datalist[item].data.images[img].hasOwnProperty("isActive")) {
                      datalist[item].data.images[img].isActive = false; //初始化选中
                    } else {
                      datalist[item].data.images[img] = {
                        isActive: false,
                        url: datalist[item].data.images[img]
                      };
                    }
                  }
                }

                //SKU
                var models = datalist[item].data.models;
                for (let val in models) {
                  models[val].list = models[val].name.split(",");
                  if (models[val].price && models[val].price_before_discount) {
                    models[val].diskaun = (models[val].price / models[val].price_before_discount * 10).toFixed(
                      1)
                  }
                  models[val].istrue = true;
                  models[val].modelid = val;
                }

                //初始化SKU类型
                if (datalist[item].data.tier_variations && datalist[item].data.tier_variations.length > 0 && !
                  self.empty(datalist[item].data.tier_variations[0].name)) {
                  //图片为空时初始化
                  for (let v in datalist[item].data.tier_variations) {
                    if (!(datalist[item].data.tier_variations[v]).hasOwnProperty("images")) {
                      datalist[item].data.tier_variations[v].images = [];
                    }

                    //SKU长度
                    let lenArr = [];
                    for(let t in datalist[item].data.tier_variations[v].options){
                      lenArr.push(self.GetBytesLength(datalist[item].data.tier_variations[v].options[t]))
                    }
                    datalist[item].data.tier_variations[v].len = lenArr;
                  }
                  datalist[item].data.is_tier_variations = true;

                  //自定义SKU
                  // datas.customize_tier_variations = self.CreateSkuArr(datas);
                  if (self.empty(datalist[item].data.customize_tier_variations)) {
                    datalist[item].data.customize_tier_variations = JSON.parse(JSON.stringify(models)); //拷贝层
                  }

                  //Sku图片列表
                  if(datalist[item].data.tier_variations[0].images && datalist[item].data.tier_variations[0].images.length > 0){
                    self.webpFilter(datalist[item].data.tier_variations[0].images);
                  }
                  for(let s in datalist[item].data.tier_variations[0].images){
                    datalist[item].data.allSkuImg = false; //初始化选中
                    if (datalist[item].data.tier_variations[0].images[s] && datalist[item].data.tier_variations[0].images[s].hasOwnProperty("isActive")) {
                      datalist[item].data.tier_variations[0].images[s].isActive = false; //初始化选中
                    } else {
                      datalist[item].data.tier_variations[0].images[s] = {
                        isActive: false,
                        url: datalist[item].data.tier_variations[0].images[s]
                      };
                    }
                  }

                } else {
                  datalist[item].data.is_tier_variations = false;
                  if (!datalist[item].data.stock) {
                    datalist[item].data.stock = 99999
                  }
                  if (!datalist[item].data.diskaun) {
                    datalist[item].data.diskaun = (datalist[item].data.price / datalist[item].data.price_before_discount *
                      10).toFixed(1)
                  }
                }

                //包裹尺码
                if (!self.empty(datalist[item].data.baglength)) {
                  datalist[item].data.baglength = datalist[item].data.baglength;
                }else{
                  datalist[item].data.baglength = 5;
                }
                if (!self.empty(datalist[item].data.bagwidth)) {
                  datalist[item].data.bagwidth = datalist[item].data.bagwidth;
                }else{
                  datalist[item].data.bagwidth = 5;
                }
                if (!self.empty(datalist[item].data.bagheight)) {
                  datalist[item].data.bagheight = datalist[item].data.bagheight;
                }else{
                  datalist[item].data.bagheight = 5;
                }

                //清除shopee采集的属性
                if(!datalist[item].data.attributes || (datalist[item].data.type == "shopee" && datalist[item].data.attributes.length > 0 && !datalist[item].data.attributes[0].hasOwnProperty("attribute_value_list"))){
                  datalist[item].data.attributes = []
                }

                //重量填充
                if(datalist[item].data.weight){
                  self.common.weight = datalist[item].data.weight
                }

              }

              //默认是否选中SKU原价
              if(!self.empty(localStorage.getItem("ExShopee_SkuPrice"))){
                self.common.skuprice = true;
              }else{
                self.common.skuprice = false;
              }

              console.log(datalist);
              self.list = datalist;
              self.list_Backup = JSON.parse(JSON.stringify(datalist)); //备份数据

              //分类属性
              self.$nextTick(() => {
                if (!datalist[0].data.attributes || datalist[0].data.attributes.length <= 0) {
                  self.get_categories(true); //自动填充分类
                }
                self.GetImgsInfo(datalist); //图片尺寸检测
                self.TitleCheck('list'); //标题、描述检测
              });

            }
          });

        }).catch(function(error) {
          console.log(error)
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      get_categories(te, ix, id, click) {
        var datas = {
          shop_id: self.shop.id
        }
        if (id) { //上级ID
          datas.category_id = id;
        }
        var _url = "/get_categories_merchant/";
        if (te) { //是否需要自动填充
          let classids = [];
          _url = "/get_categories_merchant_list/"
          for (let i in self.list) {
            classids.push(self.list[i].id);
          }
          datas.itemid = JSON.stringify(classids);
        }

        //发布列表
        if (JSON.parse(self.te)) {
          datas.type = self.te;
        }
        $.ajax({
          url: self.GetServerUrl() + _url,
          type: 'post',
          data: datas,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            var json = JSON.parse(res);
            if (json.code == 200) {
              if (!ix) {

                //是否需要自动填充
                if (te) {
                  var datas = json.datas;
                  for (let i in datas) {
                    if(datas[i].categories.length > 0 && datas[i].categories[datas[i].categories.length - 1].category_type == 1){
                      self.list[i].data.isSpecial = true;
                    }else{
                      self.list[i].data.isSpecial = false;
                    }

                    let mandatory = datas[i].attribute.mandatory_ids;
                    self.list[i].data.categories = datas[i].categories;
                    self.list_Backup[i].data.categories = JSON.parse(JSON.stringify(datas[i].categories));

                    let attributes = datas[i].attribute.data;
                    let default_attributes = JSON.parse(JSON.stringify(self.list[i].data.attributes)); //属性记录

                    //判断属性是否不为空
                    if (attributes && attributes.length > 0) {

                      //自动匹配
                      for (let y in attributes) {

                        //必填项筛选
                        for (let x in mandatory) {
                          if (mandatory[x] == attributes[y].attribute_id) {
                            attributes[y].is_mandatory = true;
                          }
                        }

                        for (let j in default_attributes) {
                          if (attributes[y].display_attribute_name == (default_attributes[j].display_attribute_name || default_attributes[j].name)) {
                            attributes[y].current_select = default_attributes[j].current_select;
                            attributes[y].current_select_en = default_attributes[j].current_select_en;
                            attributes[y].current_select_id = default_attributes[j].current_select_id;
                          }
                        }

                      }

                      self.list[i].data.attributes = JSON.parse(JSON.stringify(attributes));
                      self.list_Backup[i].data.attributes = JSON.parse(JSON.stringify(attributes));
                    }else{
                      self.list[i].data.categories = [];  //属性为空清空分类
                      self.list[i].data.attributes = [];  //属性为空清空属性
                    }

                  }

                } else {
                  self.categorieslist = [json.datas.category]
                  let categories = json.datas.categories;
                  if (categories.length > 0) {
                    self.list[self.pix].data.categories = categories;
                    // self.get_attributes(categories[categories.length - 1].catid); //加载商品属性
                  } else {
                    if (click) {
                      self.modal_box_show(self, 'Categories', '选择分类', self.categorieslist);
                    }
                  }
                }

              } else {
                var cix = parseInt(ix) + 1;
                self.categorieslist.splice(cix, self.categorieslist.length); //先删除下级
                if (json.datas.category.length > 0) {
                  self.categorieslist[cix] = json.datas.category;
                }
                self.ClassifyHtml(self.categorieslist);
              }

            } else {
              console.log(json.msg);
            }
          }
        })
      },
      get_attributes(cid) {
        self.loading = true;
        $.ajax({
          url: self.GetServerUrl() + '/get_attributes_merchant/',
          type: 'post',
          data: {
            category_id: cid,
            shop_id: self.shop.id,
          },
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            self.loading = false;
            var json = JSON.parse(res);
            if (json.code == 200) {
              let attributes = json.datas.data;
              let mandatory = json.datas.mandatory_ids;
              for (var item in attributes) {

                //必填项筛选
                for (let i in mandatory) {
                  if (mandatory[i] == attributes[item].attribute_id) {
                    attributes[item].is_mandatory = true;
                  }
                }

                if (self.pix != "all") {
                  let default_attributes = JSON.parse(JSON.stringify(self.list[self.pix].data.attributes)); //属性记录

                  //自动匹配
                  for (let z in default_attributes) {
                    if (attributes[item].display_attribute_name == default_attributes[z].display_attribute_name) {
                      attributes[item].current_select = default_attributes[z].current_select;
                      attributes[item].current_select_en = default_attributes[z].current_select_en
                      attributes[item].current_select_id = default_attributes[z].current_select_id
                    }
                  }
                }

              }

              if (self.pix == "all") {
                self.common.attributes = JSON.parse(JSON.stringify(attributes)); //隔离
                self.$nextTick(() => {
                	self.GetSize();
                });
              } else {
                self.list[self.pix].data.attributes = [];
                setTimeout(function(){
                  self.list[self.pix].data.attributes = JSON.parse(JSON.stringify(attributes)); //隔离
                },100)
              }

              self.modal_box_close();
              self.$forceUpdate();
            } else {
              layer.msg(json.msg);
            }
          },
          error: function() {
            self.loading = false;
          }
        })
      },
      ShowClassify: function(pindex) {
        self.pix = pindex;
        self.categories = []; //清空预览分类
        self.get_categories(false, false, false, true);
      },
      ClassifyHtml(datas) {
        if (self.categories.length > 0) {
          var xhtml = '<a>正在选择的：</a>'
          for (var val in self.categories) {
            xhtml += '<a class="redtxt">' + self.categories[val].display_name_zh + '「' + self.categories[val].display_name +
              '」' + '</a>'
            if (val < self.categories.length - 1) {
              xhtml += '<a class="redtxt"> > </a>'
            }
          }
          $(".ClassifyHeadLeft").html(xhtml);
        }

        var chtml = ""
        for (var item in datas) {
          if (self.categories[item] && self.categories[item].top) {
            chtml += '<div class="swiper-slide ClassifyMain" data-top="' + self.categories[item].top + '">'
          } else {
            chtml += '<div class="swiper-slide ClassifyMain" data-top="0">'
          }
          for (let i in datas[item]) {
            if (datas[item][i].istrue) {
              chtml += '<li class="ClassifyMainRow ClassifyMainActive" data-six="' + i + '" data-ix="' + item +
                '" data-name="' + datas[item][i].category_name + '" data-name_zh="' + datas[item][i].category_name_zh +
                '" data-id="' + datas[item][i].category_id + '" data-children="' + datas[item][i].has_children + '" data-ctype="' + datas[item][i].category_type + '">'
            } else {
              if(datas[item][i].category_name_zh){
                chtml += '<li class="ClassifyMainRow" data-six="' + i + '" data-ix="' + item + '" data-name="' + datas[
                  item][i].category_name + '" data-name_zh="' + datas[item][i].category_name_zh + '" data-id="' + datas[
                  item][i].category_id + '" data-children="' + datas[item][i].has_children + '" data-ctype="' + datas[item][i].category_type + '">'
              }else{
                chtml += '<li class="ClassifyMainRow" data-six="' + i + '" data-ix="' + item + '" data-name="' + datas[
                  item][i].category_name + '" data-name_zh="" data-id="' + datas[
                  item][i].category_id + '" data-children="' + datas[item][i].has_children + '" data-ctype="' + datas[item][i].category_type + '">'
              }
            }
            if(datas[item][i].category_name_zh){
              chtml += '<a>' + datas[item][i].category_name_zh + '</a>'
            }
            chtml += '<a style="color:#888;">' + datas[item][i].category_name + '</a>'
            if (datas[item][i].has_children == "True") {
              chtml += '<i class="fa fa-angle-right ClassifyMainIcon"></i>'
            }
            chtml += '</li>'
          }
          chtml += '</div>'
        }
        $("#ClassifyBox").html(chtml);

        $(".ClassifyMain").each(function() {
          var top = $(this).attr("data-top");
          $(this).scrollTop(top);
        })

        self.$forceUpdate();
        var mySwiper = new Swiper('.swiper-container', {
          slidesPerView: 'auto',
          observer: true,
          observerParents: true
        })
      },
      AllApply() {
        for (let i in self.list) {
          if (self.navix == 0) { //店铺&类目
            self.list[i].data.categories = JSON.parse(JSON.stringify(self.common.categories));
            if(self.list[i].data.categories.length > 0 && self.list[i].data.categories[self.list[i].data.categories.length - 1].category_type == 1){
              self.list[i].data.isSpecial = true;
            }else{
              self.list[i].data.isSpecial = false;
            }
            self.list[i].data.categorieslist = JSON.parse(JSON.stringify(self.common.categorieslist));
            self.list[i].data.attributes = JSON.parse(JSON.stringify(self.common.attributes));
            self.list[i].data.CurrentClassify = JSON.parse(JSON.stringify(self.common.CurrentClassify));
            console.log(self.list[i].data.attributes)
          } else if (self.navix == 1) { //基本信息
            if (self.common.name) {
              self.list[i].data.name = JSON.parse(JSON.stringify(self.common.name));
            }
            if(self.common.prefix){
              self.list[i].data.name = self.common.prefix + self.list[i].data.name;
            }
            if(self.common.suffix){
              self.list[i].data.name = self.list[i].data.name + self.common.suffix;
            }
            //标题替换
            if (self.common.search_name) {
              let se_de = self.common.search_name;
              let re_de = "";
              if (self.common.replace_name) {
                re_de = self.common.replace_name;
              }
              if (self.list[i].data.name && se_de) {
                self.list[i].data.name = self.list[i].data.name.replace(se_de, re_de);
              }
            }
            if (self.common.ProductCode) {
              self.list[i].data.ProductCode = JSON.parse(JSON.stringify(self.common.ProductCode));
            }
            if (self.common.description) {
              self.list[i].data.description = JSON.parse(JSON.stringify(self.common.description));
            }
            if(self.common.start_description){
              let des = self.common.start_description + self.list[i].data.description;
              self.list[i].data.description = JSON.parse(JSON.stringify(des));
            }
            if(self.common.end_description){
              let des =  self.list[i].data.description + self.common.end_description;
              self.list[i].data.description = JSON.parse(JSON.stringify(des));
            }
            if(self.common.search_description){
              let se_de = self.common.search_description;
              let re_de = "";
              if(self.common.replace_description){
                re_de = self.common.replace_description;
              }
              if(self.list[i].data.description && se_de){
                self.list[i].data.description = self.list[i].data.description.replace(se_de,re_de);
              }
            }
            self.TitleCheck('list'); //标题、描述检测
          } else if (self.navix == 5) { //物流信息
            self.list[i].data.pre_sale = JSON.parse(JSON.stringify(self.common.pre_sale));
            self.list[i].data.is_pre_sale = JSON.parse(JSON.stringify(self.common.is_pre_sale));
            if (self.common.baglength) {
              self.list[i].data.baglength = JSON.parse(JSON.stringify(self.common.baglength));
            }
            if (self.common.bagwidth) {
              self.list[i].data.bagwidth = JSON.parse(JSON.stringify(self.common.bagwidth));
            }
            if (self.common.bagheight) {
              self.list[i].data.bagheight = JSON.parse(JSON.stringify(self.common.bagheight));
            }
            self.$forceUpdate();
          }else if(self.navix == 6) { //发布设置
            self.list[i].data.is_listed = JSON.parse(JSON.stringify(self.common.is_listed));
            self.list[i].data.skuprice = JSON.parse(JSON.stringify(self.common.skuprice));
          }
        }
        layer.msg('批量应用完成！');
      },
      NavSwitch() {
        if (self.isShow) {
          self.isShow = false;
          $(".BulkBottomBox").hide();
        } else {
          self.isShow = true;
          $(".BulkBottomBox").show();
        }
        self.GetSize();
      },
      beautifyImg (itype,pix,ix,img) {
        this.MeiTuParams = {itype,pix,ix,img};
        MTImageEditor.openImage(img); //打开美图秀秀
        return;
        const imgs = editor.importFile(img);
        // 如果 res 为 false 表示没有进行导出操作
        if (imgs) {
            // files 为导出的文件数组， urls 为导出的文件 url 地址
            const { files } = imgs.then(imgs =>{
              var fileimgs = imgs.files;
              console.log(fileimgs);

            	//.then是接收正确返回的信息
              if(fileimgs && fileimgs.length > 0){

                var formData = new FormData();
                for (var i = 0; i < fileimgs.length; i++) {
                  formData.append(fileimgs[i].name, fileimgs[i]);
                }

                self.imgUpload(formData);
              }

            })
            .catch(err =>{
            	console.log(err) //.catch 返回报错信息
            })

        }
      },
      imgUpload(formData){
        self.loading = true;
        $.ajax({
          url: self.GetServerUrl() + "/update_file/",
          type: 'post',
          dataType: 'json',
          data: formData,
          contentType: false,
          processData: false,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            self.loading = false;
            if (res.code == 200) {
              let datas = res.datas;
              if(self.MeiTuParams.itype == "pro"){
                if(self.MeiTuParams.pix == "all"){
                  self.common.image = datas[0];
                }else{
                  self.list[self.MeiTuParams.pix].data.images[self.MeiTuParams.ix] = {
                    isActive: false,
                    url: datas[0]
                  };
                }
              }else if(self.MeiTuParams.itype == "size"){
                self.list[self.MeiTuParams.pix].data.size_chart_info.size_chart = datas[0];
              }else{
                self.list[self.MeiTuParams.pix].data.tier_variations[0].images[self.MeiTuParams.ix].url = datas[0];
              }
            } else {
              layer.msg(res.msg);
            }
          },
          error: function(error) {
            self.loading = false;
            self.ToastFun(2, error); //弹窗提醒
          }
        })
      },
      dataURLtoBlob(dataurl, name) {//base64转file
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], name, {
          type: mime,
        })
      },
      deletefile(pix, ix, te) {
        if (te == 1) { //视频
          self.datas.video_info_list[ix] = null;
        } else if (te == 2) { //SKU图片
          let deletebox = layer.confirm('选择删除类型', {
            title:"系统提示",
            btn: ['仅删除图片','删除图片和此规格'] //按钮
          }, function(){
            self.list[pix].data.tier_variations[0].images[ix].url = null;
            layer.close(deletebox);
            self.$forceUpdate();
          }, function(){
            self.list[pix].data.tier_variations[0].images.splice(ix,1);
            self.list[pix].data.tier_variations[0].options.splice(ix,1);
            self.CreateSkuArr(pix, self.list[pix].data);
          });
        }else if(te == 3){
          self.list[pix].data.size_chart_info.size_chart = '';
        } else {
          if(pix == "all"){
            self.common.image = null;
          }else{
            self.list[pix].data.images.splice(ix, 1);
          }
        }
        self.$forceUpdate();
      },
      OperateImg(te, pix, sku) {
        if (te == 1) { //保留选中
          if(sku){
            for(let i in self.list[pix].data.tier_variations[0].images){
              if(!self.list[pix].data.tier_variations[0].images[i].isActive){
                self.list[pix].data.tier_variations[0].images[i].url = null;
              }
            }
          }else{
            let imgs = [];
            for (let i in self.list[pix].data.images) {
              if (self.list[pix].data.images[i].isActive) {
                imgs.push(self.list[pix].data.images[i])
              }
            }
            self.list[pix].data.images = imgs;
          }
        } else if (te == 2) { //删除选中
          if(sku){
            let imgs = self.list[pix].data.tier_variations[0].images;
            for (let i = imgs.length - 1; i >= 0; i--) {
              if (imgs[i].isActive) {
                imgs[i].url = null;
                imgs[i].isActive = false;
              }
            }
            self.list[pix].data.allSkuImg = false;
          }else{
            let imgs = JSON.parse(JSON.stringify(self.list[pix].data.images))
            for (let i = imgs.length - 1; i >= 0; i--) {
              if (imgs[i].isActive) {
                imgs.splice(i, 1);
              }
            }
            self.list[pix].data.allImg = false;
            self.list[pix].data.images = imgs;
          }
        }
      },
      AllOperateImg(te) {
        if (te == 1) { //保留选中
          for (let x in self.list) {
            let imgs = [];
            for (let i in self.list[x].data.images) {
              if (self.list[x].data.images[i].isActive) {
                imgs.push(self.list[x].data.images[i])
              }
            }
            self.list[x].data.images = imgs;
          }
        } else { //删除选中
          for (let x in self.list) {
            let imgs = JSON.parse(JSON.stringify(self.list[x].data.images))
            for (let i = imgs.length - 1; i >= 0; i--) {
              if (imgs[i].isActive) {
                imgs.splice(i, 1);
              }
            }
            self.list[x].data.allImg = false;
            self.list[x].data.images = imgs;
          }
          self.common.allImg = false;
        }
      },
      RestorePicture(pix,etype) {
        if(etype == 'pro'){
          self.list[pix].data.images = JSON.parse(JSON.stringify(self.list_Backup[pix].data.images));
          self.list[pix].data.allImg = false;
        }else{
          self.list[pix].data.tier_variations[0].images = JSON.parse(JSON.stringify(self.list_Backup[pix].data.tier_variations[0].images));
          self.list[pix].data.allSkuImg = false;
        }
      },
      AllRestorePicture() {
        for (let i in self.list) {
          self.list[i].data.images = JSON.parse(JSON.stringify(self.list_Backup[i].data.images));
        }
      },
      KeepPicture(pix) {
        self.list[pix].data.images.splice(9, self.list[pix].data.images.length)
      },
      AllKeepPicture() {
        for (let i in self.list) {
          self.list[i].data.images.splice(9, self.list[i].data.images.length)
        }
      },
      SaleDay(pindex) {
        if (pindex == "all") {
          var val = self.common.pre_sale;
          if (isNaN(val)) {
            self.common.pre_sale = 5;
          } else {
            if (val < 5) {
              self.common.pre_sale = 5;
            } else if (val > 10) {
              self.common.pre_sale = 10;
            }
          }
        } else {
          var val = self.list[pindex].data.pre_sale;
          if (isNaN(val)) {
            self.list[pindex].data.pre_sale = 5;
          } else {
            if (val < 5) {
              self.list[pindex].data.pre_sale = 5;
            } else if (val > 10) {
              self.list[pindex].data.pre_sale = 10;
            }
          }
        }
      },
      onEnd(evt) {
        let pix = evt.from.dataset.pix;
        let ix = evt.from.dataset.ix;
        let imgs = self.list[pix].data.tier_variations[ix].images;
        if(ix == 0 && imgs.length > 0){
          let img = imgs[evt.oldIndex];
          imgs.splice(evt.oldIndex,1);
          imgs.splice(evt.newIndex,0,img);
        }
        self.CreateSkuArr(pix, self.list[pix].data);
      },
      deleteSku(pindex, te, ix, six) {
        if (te == 2) {
          self.list[pindex].data.tier_variations[ix].options.splice(six, 1);
          self.list[pindex].data.tier_variations[ix].images.splice(six, 1);
        } else {
          self.list[pindex].data.tier_variations.splice(ix, 1);
        }
        self.CreateSkuArr(pindex, self.list[pindex].data); //更新SKU表
      },
      ReductionSku() {
        for (let i in self.list) {
          self.list[i].data.tier_variations = JSON.parse(JSON.stringify(self.list_Backup[i].data.tier_variations));
          self.list[i].data.customize_tier_variations = JSON.parse(JSON.stringify(self.list_Backup[i].data.customize_tier_variations));
          self.list[i].data.models = JSON.parse(JSON.stringify(self.list_Backup[i].data.models));
          self.$forceUpdate();
        }
        console.log(self.list)
      },
      AddSku(pindex) {
        self.list[pindex].data.tier_variations.push({
          images: [],
          name: null,
          options: []
        });
      },
      EditSku(pindex, ix, six, txt) {
        editType = "one"; //回车触发类型
        self.pix = pindex;
        skuinfo = {
          ix: ix,
          six: six,
          txt: txt
        };
        layer.prompt({
          title: '属性修改',
          value: txt
        }, function(text, index) {
          for (let i in self.list[pindex].data.tier_variations[ix].options) {
            if (self.list[pindex].data.tier_variations[ix].options[i] == text) {
              layer.msg('该属性已存在，请勿重复添加！');
              return;
            }
          }
          if(self.GetBytesLength(text) > 30){
            layer.msg('长度'+self.GetBytesLength(text)+'，字符长度不能超过30位！');
            return;
          }
          self.EditFun(pindex, ix, six, text);
          layer.close(index);

        });
      },
      EditFun(pindex, ix, six, text) {
        if(text.substring(0,1) == " " || text.substring(text.length-1,text.length) == " "){
            layer.msg('属性名前后不能带空格符号！');
            return;
        }

        //修改ModelSKU名称以防更改后无法匹配上
        var models = self.list[pindex].data.models;
        var customize_tier_variations = self.list[pindex].data.customize_tier_variations;
        for (let i in models) {
          if ((models[i].list[ix].toLowerCase()).replace(/[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "") == (self.list[
              pindex].data.tier_variations[ix].options[six].toLowerCase()).replace(
              /[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "")) {
            models[i].list[ix] = text;
            let name = "";
            for (let x in models[i].list) {
              if (x == models[i].list.length - 1) {
                name += models[i].list[x]
              } else {
                name += models[i].list[x] + ','
              }
            }
            models[i].name = name;
            customize_tier_variations[i].name = name;
          }
        }
        self.list[pindex].data.tier_variations[ix].options[six] = text;
        self.list[pindex].data.tier_variations[ix].edit = null
        self.CreateSkuArr(pindex, self.list[pindex].data);
      },
      CreateSkuArr(pindex, datas, backup) {
        var skulist = [];
        var models = self.list[pindex].data.models;
        var customize_tier_variations = self.list[pindex].data.customize_tier_variations;
        if(backup){
          models = JSON.parse(JSON.stringify(self.list_Backup[pindex].data.models));
          customize_tier_variations = JSON.parse(JSON.stringify(self.list_Backup[pindex].data.customize_tier_variations));
        }
        if (datas.tier_variations && datas.tier_variations.length > 0) {
          if (datas.tier_variations[0].options.length > 0) {
            for (let y in datas.tier_variations[0].options) {

              var sku1 = datas.tier_variations[0].options[y];
              if (datas.tier_variations.length > 1 && datas.tier_variations[1].options.length > 0) { //二级SKU
                for (let z in datas.tier_variations[1].options) {
                  var sku2 = datas.tier_variations[1].options[z];
                  skulist.push({
                    name: sku1 + ',' + sku2,
                    list: [sku1, sku2],
                    stock: 999,
                    price: null,
                    price_before_discount: null,
                    istrue: true,
                    diskaun: null
                  })
                }
              } else { //一级SKU

                for (let m in models) {
                  if (models[m].list[0] == sku1) {
                    models[m].name = sku1;
                  }
                }

                skulist.push({
                  name: sku1,
                  list: [sku1],
                  stock: 999,
                  price: null,
                  price_before_discount: null,
                  istrue: true,
                  diskaun: null
                })
              }

            }
          } else if (datas.tier_variations.length > 1 && datas.tier_variations[1].options.length > 0) { //二级SKU
            for (let z in datas.tier_variations[1].options) {
              var sku2 = datas.tier_variations[1].options[z];

              for (let m in models) {
                if (models[m].list[1] == sku2) {
                  models[m].name = sku2;
                }
              }

              skulist.push({
                name: sku2,
                list: ['', sku2],
                stock: 999,
                price: null,
                price_before_discount: null,
                istrue: true,
                diskaun: null
              })
            }
          }
        }

        //models价格、库存填充
        for (let q in models) {
          for (let w in skulist) {
            if ((models[q].name.toLowerCase()).replace(/[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "") == (skulist[w].name.toLowerCase())
              .replace(/[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "")) { //索引校验
              skulist[w].modelid = models[q].modelid;
              skulist[w].price = models[q].price;
              skulist[w].stock = models[q].stock;
              skulist[w].price_before_discount = models[q].price_before_discount;
              skulist[w].istrue = true,
                skulist[w].diskaun = models[q].diskaun;
            }
          }
        }
        self.list[pindex].data.models = JSON.parse(JSON.stringify(skulist));

        //customize_tier_variations价格、库存填充
        for (let q in customize_tier_variations) {
          for (let w in skulist) {
            if ((customize_tier_variations[q].name.toLowerCase()).replace(/[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "") == (skulist[w].name.toLowerCase())
              .replace(/[^a-zA-Z\d\u4e00-\u9fa5,.!?()，．；;？]/g, "")) { //索引校验
              skulist[w].modelid = customize_tier_variations[q].modelid;
              skulist[w].price = customize_tier_variations[q].price;
              skulist[w].stock = customize_tier_variations[q].stock;
              skulist[w].price_before_discount = customize_tier_variations[q].price_before_discount;
              skulist[w].istrue = true,
                skulist[w].diskaun = customize_tier_variations[q].diskaun;
            }
          }
        }
        self.list[pindex].data.customize_tier_variations = JSON.parse(JSON.stringify(skulist));

        self.SkuLengthCheck(pindex); //属性字节长度
        self.$forceUpdate();
      },
      RecoverPrice() {
        for (let i in self.list) {
          let te = self.list[i].data.is_tier_variations;
          if(te){
            self.list[i].data.customize_tier_variations = JSON.parse(JSON.stringify(self.list[i].data.models));
          }else{
            self.list[i].data.price = JSON.parse(JSON.stringify(self.list_Backup[i].data.price));
            self.list[i].data.price_before_discount = JSON.parse(JSON.stringify(self.list_Backup[i].data.price_before_discount));
          }
        }
      },
      AllCountPrice() {
        for (let i in self.list) {
          self.CountPrice(self.list[i].data, i);
        }
      },
      CountPrice(datas, pix) {
        let weight = self.common.weight; //定价模板
        let te = datas.is_tier_variations;

        //单SKU和多SKU
        var variations;
        if (te) {
          variations = JSON.parse(JSON.stringify(datas.customize_tier_variations)); //变体价格
        } else {
          variations = [{
            price: datas.price,
            price_before_discount: datas.price_before_discount,
            istrue: true
          }]; //变体价格
        }

        let country = self.shop.country; //当前站点
        let cpricing = self.GetPricing();
        self.AllPricingToolGlobal(pix, country, weight, variations, cpricing, te)
      },
      OpenPage(url) {
        localStorage.setItem("ExShopee_NavSubIx", 0);
        window.open(self.GetServerLink() + '#/' + url);
      },
      get_pricing() {
        let param = new URLSearchParams()
        param.append('is_merchant', 2)
        axios({
          method: 'post',
          data: param,
          url: self.GetServerUrl() + "/price_template_list/?is_page=0",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(json) {
            var datas = json.list;
            for (let item in datas) {
              datas[item].is_select = datas[item].is_default;
              if (!datas[item].name) {
                datas[item].name = "定价模板" + datas[item].id
              }
              if(datas[item].is_select){
                self.pricing_type = datas[item].e_type;
              }
            }
            self.pricing = datas;
          });

        }).catch(function(error) {
          console.log(error);
        })
      },
      ClosePage() {
        this.$router.go(-1); //返回上一层
      },
      SaveEdit(etype) {
        var datas = self.list;
        for(let i in self.list){
          self.list[i].data.pricing = self.GetPricing();
        }

        self.loading = true;
        let param = new URLSearchParams()
        if (JSON.parse(self.te)) {
          if(self.list[0].type != 3 && self.empty(etype)){
            param.append('type', self.te)
          }
        }
        param.append('shop_id', self.shop.id)
        param.append('datas', JSON.stringify(datas))
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/product_merchant_save_batch/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          timeout:60000,
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            localStorage.setItem("ExShopee_baglength", self.common.baglength); //缓存包裹属性
            localStorage.setItem("ExShopee_bagwidth", self.common.bagwidth); //缓存包裹属性
            localStorage.setItem("ExShopee_bagheight", self.common.bagheight); //缓存包裹属性
            localStorage.setItem("ExShopee_HistoryURL", "Global");
            self.$router.push({
              path: "Global?ix=0"
            }) // 路由跳转
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
        console.log(self.list)
      },
      Release() {
        var datas = self.list;
        //必填判断
        for (let item in self.list) {

          //Sku名字组合
          if(self.list[item].data.is_tier_variations){
            if(self.empty(self.list[item].data.is_skuprice)){
              self.list[item].data.is_skuprice = true;
              for(let x in self.list[item].data.customize_tier_variations){
                //自动sku货号
                self.list[item].data.customize_tier_variations[x].name = self.list[item].data.ProductCode +"_"+ self.list[item].data.customize_tier_variations[x].name;
                //自动sku原价
                if(self.list[item].data.skuprice){
                  self.list[item].data.customize_tier_variations[x].name = self.list[item].data.models[x].price +"-"+ self.list[item].data.customize_tier_variations[x].name;
                }
              }
            }
          }

          //标题判断
          self.TitleCheck(item,1);
          if(self.list[item].data.titleHint){
            self.NavActive(1);
            self.PositionJump("basic-box"+item); //位置跳转
            return;
          }

          //描述判断
          self.TitleCheck(item,2);
          if(self.list[item].data.desHint){
            self.NavActive(1);
            self.PositionJump("basic-box"+item); //位置跳转
            return;
          }

          //商品货号
          if (self.empty(self.list[item].data.ProductCode)) {
            self.NavActive(1);
            layer.msg('商品货号不能为空！');
            return;
          }

          //商品分类
          if (self.list[item].data.categories.length <= 0) {
            self.NavActive(0);
            layer.msg('商品分类不能为空！');
            self.PositionJump("shop-box"+item); //位置跳转
            return;
          }

          //商品属性
          for (let i in self.list[item].data.attributes) {
            if (self.list[item].data.attributes[i].is_mandatory && !self.list[item].data.attributes[i].current_select_en) {
              self.NavActive(0);
              layer.msg('必选属性不能为空！');
              self.PositionJump("shop-box"+item); //位置跳转
              return;
            }
            if(self.list[item].data.attributes[i].input_type == "TEXT_FILED"){
              if(self.list[item].data.attributes[i].current_select_en && self.list[item].data.attributes[i].current_select_en != ''){
                self.list[item].data.attributes[i].current_select_id = 0;
              }else{
                self.list[item].data.attributes[i].current_select_id = null;
                self.list[item].data.attributes[i].current_select_en = null;
              }

              //暂时不传单位
              if(self.list[item].data.attributes[i].attribute_unit.length > 0){
                self.list[item].data.attributes[i].current_select_id = null;
                self.list[item].data.attributes[i].current_select_en = null;
              }

            }
            if(self.list[item].data.attributes[i].current_select_en && self.list[item].data.attributes[i].input_validation_type == "DATE_TYPE"){
              self.list[item].data.attributes[i].current_select_en = Date.parse(self.list[item].data.attributes[i].current_select_en);
            }
          }

          //图片数量限制
          if (self.list[item].data.images.length > 9) {
            self.NavActive(2);
            layer.msg('图片数量不能超过9张！');
            self.PositionJump("img-box"+item); //位置跳转
            return;
          }

          //图片数量限制
          if (self.list[item].data.images.length <= 0) {
            self.NavActive(2);
            layer.msg('图片不能为空！');
            self.PositionJump("img-box"+item); //位置跳转
            return;
          }

          //SKU属性长度判断
          for(let i in self.list[item].data.tier_variations){
            for(let x in self.list[item].data.tier_variations[i].len){
              if(self.list[item].data.tier_variations[i].len[x] > 30){
                self.NavActive(3);
                layer.msg('SKU名称长度不能超过30字符！');
                self.PositionJump("sku-box"+item); //位置跳转
                return;
              }
            }
          }

          //SKU数量提示
          if(self.list[item].data.customize_tier_variations && self.list[item].data.customize_tier_variations.length > 50){
            self.NavActive(3);
            layer.msg('SKU数量不能超过50个！');
            self.PositionJump("sku-box"+item); //位置跳转
            return;
          }

          //SKU完整判断
          if (self.list[item].data.is_tier_variations) {
            if (!self.list[item].data.customize_tier_variations) {
              self.NavActive(3);
              layer.msg('规格属性不能为空！');
              self.PositionJump("sku-box"+item); //位置跳转
              return;
            }

            var fprice,minprice=0,maxprice=0;
            for(let c in self.list[item].data.customize_tier_variations){
              if(self.list[item].data.customize_tier_variations[c].price){
                fprice = self.list[item].data.customize_tier_variations[c].price;
              }
              var price = self.list[item].data.customize_tier_variations[c].price;
              self.list[item].data.weight = self.list[item].data.customize_tier_variations[c].weight;
              if(self.empty(price)){
                if(!fprice){
                  fprice = self.list[item].data.price;
                }
                self.list[item].data.customize_tier_variations[c].price = fprice;
                self.list[item].data.customize_tier_variations[c].stock = 0;
                // self.NavActive(4);
                // layer.msg('SKU价格不能为空！');
                // self.PositionJump("sku-table"+item);
              }
              var cprice =  parseFloat(self.list[item].data.customize_tier_variations[c].price)
              if(!minprice || minprice > cprice){
                minprice = cprice;
              }
              if(!maxprice || maxprice < cprice){
                maxprice = cprice;
              }

              //库存不能超过最大
              if(self.list[item].data.customize_tier_variations[c].stock > 500000){
                self.list[item].data.customize_tier_variations[c].stock = 500000
              }

            }
            // console.log(minprice)
            // console.log(maxprice)

          } else {
            //库存不能超过最大
            if(self.list[item].data.stock > 500000){
              self.list[item].data.stock = 500000
            }

            if (self.empty(self.list[item].data.price)) {
              self.NavActive(4);
              layer.msg('价格不能为空！');
              return;
            }
          }

          //SKU图片完整检测
          var isNull = [];
          if(self.list[item].data.tier_variations && self.list[item].data.tier_variations.length > 0){
            for(let i in self.list[item].data.tier_variations[0].images){
              if(self.list[item].data.tier_variations[0].images[i].url){
                isNull.push(self.list[item].data.tier_variations[0].images[i]);
              }
              if(isNull.length > 0 && !self.list[item].data.tier_variations[0].images[i].url){
                self.NavActive(3);
                layer.msg("SKU图片不完整，只能全有或全无！");
                return;
              }
            }
          }

          //包裹重量
          if (self.empty(self.common.weight)) {
            self.NavActive(4);
            layer.msg('包裹重量不能为空！');
            return;
          } else {
            if(!self.list[item].data.weight){
              self.list[item].data.weight = self.common.weight;
            }
          }

          //包裹尺寸设置
          if(self.list[item].data.baglength){
            self.list[item].data.baglength = parseInt(self.list[item].data.baglength)
          }else{
            self.list[item].data.baglength = 5
          }
          if(self.list[item].data.bagwidth){
            self.list[item].data.bagwidth = parseInt(self.list[item].data.bagwidth)
          }else{
            self.list[item].data.bagwidth = 5
          }
          if(self.list[item].data.bagheight){
            self.list[item].data.bagheight = parseInt(self.list[item].data.bagheight)
          }else{
            self.list[item].data.bagheight = 5
          }

          //定价模板
          self.list[item].data.pricing = self.GetPricing();  //定价添加
          // if(self.GetPricing()){
          //   self.list[item].data.pricing = self.GetPricing();  //定价添加
          // }else{
          //   self.NavActive(4);
          //   layer.msg('定价模板不能为空！');
          //   return;
          // }

          //定时发布
          if(!self.common.publish_now && !self.common.publish_date){
            layer.msg('请选择定时发布时间！');
            self.NavActive(6);
            return;
          }

        }

        let navix = 1;
        self.loading = true;
        let param = new URLSearchParams()
        if (JSON.parse(self.te)) {
          param.append('type', self.te)
        }
        param.append('shop_id', self.shop.id)
        param.append('datas', JSON.stringify(datas))
        if(!self.common.publish_now){
          navix = 4;
          param.append('publish_date', self.common.publish_date);
          param.append('publish_rate', self.common.publish_rate);
        }
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/product_add_merchant_batch/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          timeout:60000,
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            localStorage.setItem("ExShopee_baglength", self.common.baglength); //缓存包裹属性
            localStorage.setItem("ExShopee_bagwidth", self.common.bagwidth); //缓存包裹属性
            localStorage.setItem("ExShopee_bagheight", self.common.bagheight); //缓存包裹属性
            localStorage.setItem("ExShopee_NavSubIx", 3); //导航缓存
            localStorage.setItem("ExShopee_HistoryURL", "Global");
            self.$router.push({
              path: "Global?ix="+navix
            }) // 路由跳转
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })

      },
      AllTranslation() {
        self.loading = true;
        let param = new URLSearchParams()
        param.append('to_lang', "zh")
        if(self.list[0].data.country == "TW"){
          param.append('from_lang', "cht")
        }else{
          param.append('from_lang', "en")
        }
        param.append('data', JSON.stringify(self.list))
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/translation_list/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            console.log(datas)
            self.list = datas;
            self.$forceUpdate();
            layer.msg('字体翻译完成！');
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      CloseTips() {
        self.isTips = false;
        localStorage.setItem("ExShopee_isTips", true);
      },
      ReductionItem(pix, ix) {
        if (ix == 0) {
          self.list[pix].data.categories = JSON.parse(JSON.stringify(self.list_Backup[pix].data.categories));
          self.list[pix].data.attributes = [];
          setTimeout(function() {
            self.list[pix].data.attributes = JSON.parse(JSON.stringify(self.list_Backup[pix].data.attributes));
          }, 100)
        } else if (ix == 1) {
          self.list[pix].data.name = JSON.parse(JSON.stringify(self.list_Backup[pix].data.name));
          self.list[pix].data.ProductCode = JSON.parse(JSON.stringify(self.list_Backup[pix].data.ProductCode));
          self.list[pix].data.description = JSON.parse(JSON.stringify(self.list_Backup[pix].data.description));
        } else if (ix == 3) {
          self.list[pix].data.tier_variations = JSON.parse(JSON.stringify(self.list_Backup[pix].data.tier_variations));
          self.list[pix].data.customize_tier_variations = JSON.parse(JSON.stringify(self.list_Backup[pix].data.customize_tier_variations));
          self.list[pix].data.models = JSON.parse(JSON.stringify(self.list_Backup[pix].data.models));
          self.list[pix].data.is_skuprice = false;
        } else if (ix == 4) {
          if(self.list[pix].data.is_tier_variations){
            let customize = self.list[pix].data.customize_tier_variations;
            let customize_backup =  self.list_Backup[pix].data.customize_tier_variations;
            for(let i in customize){
              for(let x in customize_backup){
                if(customize[i].list.length == 2){
                  if(customize[i].list[0] == customize_backup[x].list[0] && customize[i].list[1] == customize_backup[x].list[1]){
                    if(customize[i].weight){
                      customize_backup[x].weight = JSON.parse(JSON.stringify(customize[i].weight));
                    }
                    customize[i] = JSON.parse(JSON.stringify(customize_backup[x]));
                  }
                  self.list[pix].data.is_skuprice = false;
                }else if(customize[i].list.length == 1){
                  if(customize[i].list[0] == customize_backup[x].list[0]){
                    if(customize[i].list[0] == customize_backup[x].list[0] && customize[i].list[1] == customize_backup[x].list[1]){
                      if(customize[i].weight){
                        customize_backup[x].weight = JSON.parse(JSON.stringify(customize[i].weight));
                      }
                      customize[i] = JSON.parse(JSON.stringify(customize_backup[x]));
                    }
                  }
                }
              }
            }
          }else{
            self.list[pix].data.price = JSON.parse(JSON.stringify(self.list_Backup[pix].data.price));
            self.list[pix].data.stock = JSON.parse(JSON.stringify(self.list_Backup[pix].data.stock));
          }
          self.list[pix].data.is_skuprice = false;
          self.$forceUpdate();
        } else if (ix == 5) {
          self.list[pix].data.is_pre_sale = JSON.parse(JSON.stringify(self.list_Backup[pix].data.is_pre_sale));
          self.list[pix].data.pre_sale = JSON.parse(JSON.stringify(self.list_Backup[pix].data.pre_sale));
          self.list[pix].data.baglength = JSON.parse(JSON.stringify(self.list_Backup[pix].data.baglength));
          self.list[pix].data.bagwidth = JSON.parse(JSON.stringify(self.list_Backup[pix].data.bagwidth));
          self.list[pix].data.bagheight = JSON.parse(JSON.stringify(self.list_Backup[pix].data.bagheight));
        }
        self.$forceUpdate();
      },
      Reduction (pix,ix) {
        self.list[pix].data.tier_variations[ix] = JSON.parse(JSON.stringify(self.list_Backup[pix].data.tier_variations[ix]));
        self.CreateSkuArr(pix,self.list[pix].data,true); //更新SKU表
      },
      RemoveItem(pix) {
        self.list.splice(pix, 1);
      },
      Origin(url) {
        window.open(url);
      },
      InputDetection(name, pix, origin, ix) {
        var price, diskaun, price_before_discount;
        var _price, _diskaun;
        if (origin == 1) {
          //价格、折扣、重量、库存只能为数字
          if(isNaN(eval('self.list[pix].data.'+name)) || eval('self.list[pix].data.'+name) == " "){
            eval('self.list[pix].data.'+name+'= self.list_Backup[pix].data.'+name)
          }

          price = Number(self.list[pix].data.price);
        } else if(origin == 2) {
          //价格、折扣、重量、库存只能为数字
          if(isNaN(eval('self.list[pix].data.customize_tier_variations[ix].'+name)) || eval('self.list[pix].data.customize_tier_variations[ix].'+name) == " "){
            eval('self.list[pix].data.customize_tier_variations[ix].'+name+'= self.list_Backup[pix].data.customize_tier_variations[ix].'+name)
          }

          price = Number(self.list[pix].data.customize_tier_variations[ix].price);
        } else {
          //价格、折扣、重量、库存只能为数字
          if(isNaN(eval('self.common.'+name)) || eval('self.common.'+name) == " "){
            eval('self.common.'+name+'= null')
          }
        }
        self.$forceUpdate();
      },
      WaterPrint(pix,id) {

        let imgs = [],datas = [];
        var _url = "/water_print/";
        if (pix == "all") {
          _url = "/water_print_list/"
          for (let x in self.list) {
            for (let i in self.list[x].data.images) {
              if (self.list[x].data.images[i].isActive) {
                imgs.push(self.list[x].data.images[i]);
                datas[x] = self.list[x].data.images
              }
            }
          }
        } else {
          if(self.list[pix].data.etype == "pro"){
            for (let i in self.list[pix].data.images) {
              if (self.list[pix].data.images[i].isActive) {
                imgs.push(self.list[pix].data.images[i]);
                datas = self.list[pix].data.images
              }
            }
          }else{
            for (let i in self.list[pix].data.tier_variations[0].images) {
              if (self.list[pix].data.tier_variations[0].images[i].isActive) {
                imgs.push(self.list[pix].data.tier_variations[0].images[i]);
                datas = self.list[pix].data.tier_variations[0].images
              }
            }
          }
        }

        if (imgs.length > 0) {
          self.loading = true;
          let param = new URLSearchParams();
          param.append('id', id);
          param.append('images', JSON.stringify(datas));
          axios({
            method: 'post',
            url: self.GetServerUrl() + _url,
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {
            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.isClick = false;
              $(".WatermarkMenu").hide();
              $(".module-img-list").html("");

              if (pix == "all") {
                for (let i in datas) {
                  if (datas[i]) {
                    self.list[i].data.WatermarkImages = datas[i];
                    self.RenderWatermarkPicList(i);
                  }
                }
              } else {
                self.list[pix].data.WatermarkImages = datas;
                self.RenderWatermarkPicList(pix);
              }

              layer.msg("水印处理完成！");
            }, false, true);
          }).catch(function(error) {
            self.loading = false;
            layer.msg("水印设置失败，请重试！");
          })
        } else {
          self.ToastFun(1, '请先选择图片！'); //弹窗提醒
        }

      },
      GetWatermarkList(){
        let list = [];
        for(let i in self.list){
          for(let x in self.list[i].data.images){
            if(self.list[i].data.images[x].isActive){
              if($.inArray(i,list) == -1){
                list.push(i);
              }
            }
          }
        }
        return list;
      },
      ShowWaterPrint (pindex,etype) {
        let imgs = [];
        self.pix = pindex;
        if(pindex == 'all'){
          for (let x in self.list) {
            for(let y in self.list[x].data.images){
              if (self.list[x].data.images[y].isActive) {
                imgs.push(self.list[x].data.images[y])
              }
            }
          }
        }else{
          self.list[pindex].data.etype = etype;
          if(etype == "pro"){
            for (let i in self.list[pindex].data.images) {
              if (self.list[pindex].data.images[i].isActive) {
                imgs.push(self.list[pindex].data.images[i])
              }
            }
          }else{
            for (let i in self.list[pindex].data.tier_variations[0].images) {
              if (self.list[pindex].data.tier_variations[0].images[i].isActive) {
                imgs.push(self.list[pindex].data.tier_variations[0].images[i])
              }
            }
          }
        }

        if(imgs.length <= 0){
         layer.msg("请选择图片！");
          return;
        }

        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        xmlModule = layer.open({
          type: 1,
          offset: '100px',
          title: "图片水印",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定', '取消'],
          content: WaterPrintHtml,
          success: function() {

            var isList = self.GetWatermarkList();
            $(".module-img-list").html("");
            if(pindex == 'all'){
              for(let i in self.list){
                if($.inArray(i,isList) != -1){
                  self.list[i].data.WatermarkImages = JSON.parse(JSON.stringify(self.list[i].data.images));
                  self.RenderWatermarkPicList(i);
                }
              }
            }else{
              if(etype == "pro"){
                self.list[pindex].data.WatermarkImages = JSON.parse(JSON.stringify(self.list[pindex].data.images));
              }else{
                self.list[pindex].data.WatermarkImages = JSON.parse(JSON.stringify(self.list[pindex].data.tier_variations[0].images));
              }
              self.RenderWatermarkPicList(pindex);
            }


            form.on('submit(SetWatermark)', function(data){
              if(!WatermarkList || WatermarkList.length <= 0){
                layer.msg("水印模板为空，请先添加模板！");
                return;
              }

              let xml = ""
              for(let i in WatermarkList){
                xml += '<li class="NoSelect" data-id="'+WatermarkList[i].id+'">'+WatermarkList[i].name+'</li>'
              }
              if($(".WatermarkMenu").is(":visible")){
                $(".WatermarkMenu").hide();
              }else{
                $(".WatermarkMenu").html(xml).show();
              }

              //点击水印模板
              $(".WatermarkMenu li").click(function(){
                let id = $(this).attr("data-id");
                self.WaterPrint(pindex,id);
              })

            });
            form.on('submit(AddWaterPrint)', function(data){
              self.AddWatermarkTemplate();
            });
            form.on('submit(ClearWaterPrint)', function(data){
              $(".module-img-list").html("");
              if(pindex == 'all'){
                for(let i in self.list){
                  if($.inArray(i,isList) != -1){
                    self.list[i].data.WatermarkImages = JSON.parse(JSON.stringify(self.list[i].data.images));
                    self.RenderWatermarkPicList(i);
                  }
                }
              }else{
                if(self.list[pindex].data.etype == "pro"){
                  self.list[pindex].data.WatermarkImages = JSON.parse(JSON.stringify(self.list[pindex].data.images));
                }else{
                  self.list[pindex].data.WatermarkImages = JSON.parse(JSON.stringify(self.list[pindex].data.tier_variations[0].images));
                }
                self.RenderWatermarkPicList(pindex);
              }
              layer.msg("清除水印完成！");
            });
            form.on('submit(WaterPrintList)', function(data){
              self.WatermarkListModule();
            });

            self.WatermarkList(); //加载水印列表

            form.render();
          },
          yes: function(index, layero) {
            var isList = self.GetWatermarkList();
            if(self.pix == 'all'){
              for(let i in self.list){
                if($.inArray(i,isList) != -1){
                  self.list[i].data.images = JSON.parse(JSON.stringify(self.list[i].data.WatermarkImages));
                }
              }
            }else{
              if(self.list[self.pix].data.etype == "pro"){
                self.list[self.pix].data.images = JSON.parse(JSON.stringify(self.list[self.pix].data.WatermarkImages));
              }else{
                self.list[self.pix].data.tier_variations[0].images = JSON.parse(JSON.stringify(self.list[self.pix].data.WatermarkImages));
              }
            }

            layer.close(xmlModule);
            self.$forceUpdate();
          }
        });
      },
      RenderWatermarkPicList (pindex){
        var xml = "";
        for(let i in self.list[pindex].data.WatermarkImages){
         if(self.list[pindex].data.WatermarkImages[i].isActive){
           xml += "<li>"
           xml += '<p class="col-img layui-form WatermarkListImage" data-img="'+self.list[pindex].data.WatermarkImages[i].url+'" style="background-image: url('+self.list[pindex].data.WatermarkImages[i].url+')"></p>'
           xml += "</li>"
         }
        }
        $(".module-img-list").append(xml);
      },
      AddWatermarkTemplate (id) {
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        xmlTwoModule = layer.open({
          type: 1,
          offset: '100px',
          title: "添加水印模板",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定', '取消'],
          content: AddWaterPrintHtml,
          success: function() {
            var imgs = [],sliderDVal = 1;

            //编辑
            if(id){
              for(let i in WatermarkList){
                if(WatermarkList[i].id == id){
                  sliderDVal = 10 - WatermarkList[i].transparency * 10;
                  $("#WaterPType input[name=WaterPType][value="+WatermarkList[i].water_type+"]").prop("checked", "true");
                  $("#WaterPLog input[name=WaterPLog][value="+WatermarkList[i].position+"]").prop("checked", "true");
                  $("#WaterPName").val(WatermarkList[i].name);
                  if(WatermarkList[i].water_type == 1){
                    $("#WaterPImg").attr("src",WatermarkList[i].water_img);
                    $(".WaterPImgBox,.WaterPImg").show();
                    $(".WaterPTxt,.WaterPfont").hide();
                  }else{
                    $("#WaterPTxt").val(WatermarkList[i].text);
                    $("#WaterPSize").val(WatermarkList[i].text_size);
                    $(".WaterPImgBox,.WaterPImg").hide();
                    $(".WaterPTxt,.WaterPfont").show();
                    $(".WaterPfont").text(WatermarkList[i].text);
                    $("#WaterPBox").css({'fontSize':WatermarkList[i].text_size+'px'});
                  }
                  $("#WaterPX").val(WatermarkList[i].position_x);
                  $("#WaterPY").val(WatermarkList[i].position_y);
                }
              }
            }else{
              self.WatermarkID = null;
            }

            slider.render({
              elem: '#SlideOpacity',
              step: 1, //步长
              min:1,
              max:10,
              value:sliderDVal,
              change: function(val){
                sliderVal = val;
                if(!isSlider){
                  isSlider = true;
                  setTimeout(function(){
                    self.WaterPLocation();
                    isSlider = false;
                  },300)
                }
              }
            });

            //水印类型
            form.on('radio(WaterPType)', function(data) {
              if(data.value == 1){
                $(".WaterPImgBox,.WaterPImg").show();
                $(".WaterPTxt,.WaterPfont").hide();
              }else if(data.value == 2){
                $(".WaterPImgBox,.WaterPImg").hide();
                $(".WaterPTxt,.WaterPfont").show();
              }
              form.render();
            });

            $("#WaterPX").change(function(){
              self.WaterPLocation();
            })
            $("#WaterPY").change(function(){
              self.WaterPLocation();
            })
            self.WaterPLocation();
            $("#WaterPTxt").change(function(){
              $("#WaterPfont").text($(this).val());
              self.WaterPLocation();
            })
            $("#WaterPSize").change(function(){
              $("#WaterPfont").css({'fontSize':$(this).val()+'px'});
              self.WaterPLocation();
            })
            form.on('radio(WaterPLog)', function(data) {
              self.WaterPLocation();
            });

            form.render();
          },
          yes: function(index, layero) {
            let WaterPType = $('#WaterPType input[name="WaterPType"]:checked').val();
            let WaterPName = $("#WaterPName").val();
            let WaterPImg = $("#WaterPImg").attr("src");
            let WaterPTxt = $("#WaterPTxt").val();
            let WaterPSize = $("#WaterPSize").val();
            let WaterPLog = $('#WaterPLog input[name="WaterPLog"]:checked').val()
            let WaterPX = $("#WaterPX").val();
            let WaterPY = $("#WaterPY").val();
            let op = (1-sliderVal*0.1).toFixed(2);

            let param = new URLSearchParams();
            if(self.WatermarkID){
              param.append('id', self.WatermarkID);
            }
            if(!WaterPName){
                layer.msg("模板名称不能为空！");
              return;
            }
            if(WaterPType == 1){ //图片
              if(!WaterPImg){
                layer.msg("图片不能为空！");
                return;
              }
              param.append('water_img', WaterPImg);
            }else{ //文字
              if(!WaterPTxt){
                layer.msg("文字不能为空！");
                return;
              }
              if(!WaterPSize){
                layer.msg("文字大小不能为空！");
                return;
              }
              param.append('text', WaterPTxt);
              param.append('text_size', WaterPSize);
            }

            self.loading = true;
            param.append('water_type', WaterPType);
            param.append('name', WaterPName);
            param.append('position', WaterPLog);
            param.append('position_x', WaterPX);
            param.append('position_y', WaterPY);
            param.append('transparency', op);

            axios({
              method: 'post',
              url: self.GetServerUrl() + "/store_water/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {
              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                self.WatermarkList();
                layer.msg("水印模板添加成功！");
                layer.close(xmlTwoModule);
              }, false, true);
            }).catch(function(error) {
              self.loading = false;
              console.log(error);
            })
          }
        });
      },
      WaterPLocation () {
        let boxw = $(".WaterPBox").width()/2;
        let boxh = $(".WaterPBox").height()/2;
        let xp = $("#WaterPX").val();
        let yp = $("#WaterPY").val();
        let log = $('#WaterPLog input[name="WaterPLog"]:checked').val()
        let op = 1-sliderVal*0.1;
        let cssdis = {};
        $("#OffsetBox").show();
        if(log == 1 || log == 4 || log == 7){
          $("#WaterPXBox").show();
          $("#WaterPYBox").show();
          if(log == 1){
            cssdis = {left:xp+'px',top:yp+'px'}
          }else if(log == 4){
            $("#WaterPYBox").hide();
            cssdis = {left:xp+'px',top:'calc(50% - '+boxh+'px)'}
          }else if(log == 7){
            cssdis = {left:xp+'px',bottom:yp+'px'}
          }
        }else if(log == 2 || log == 5 || log == 8){
          $("#WaterPXBox").hide();
          $("#WaterPYBox").show();
          if(log == 2){
            cssdis = {left:'calc(50% - '+boxw+'px)',top:yp+'px'}
          }else if(log == 5){
            $("#WaterPYBox,#OffsetBox").hide();
            cssdis = {left:'calc(50% - '+boxw+'px)',top:'calc(50% - '+boxh+'px)'}
          }else if(log == 8){
            cssdis = {left:'calc(50% - '+boxw+'px)',bottom:yp+'px'}
          }
        }else if(log == 3 || log == 6 || log == 9){
          $("#WaterPXBox").show();
          $("#WaterPYBox").show();
          if(log == 3){
            cssdis = {right:xp+'px',top:yp+'px'}
          }else if(log == 6){
            $("#WaterPYBox").hide();
            cssdis = {right:xp+'px',top:'calc(50% - '+boxh+'px)'}
          }else if(log == 9){
            cssdis = {right:xp+'px',bottom:yp+'px'}
          }
        }
        cssdis.opacity = op;
        $(".WaterPBox").removeAttr("style").css(cssdis);
      },
      WatermarkList (te) {
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_water_list/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          self.loading = false;
          var json = res.data;
          if(json.code == 200){
            let list = json.datas.list;
            WatermarkList = list;
            $(".WatermarkMenu").hide();
          }else{
            WatermarkList = null;
          }
          if(te){
            self.RenderWatermarkList();
          }

        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      WatermarkListModule () {
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        xmlThreeModule = layer.open({
          type: 1,
          offset: '100px',
          title: "管理水印模板",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['刷新列表', '取消'],
          content: WatermarkListHtml,
          success: function() {
            self.RenderWatermarkList();
            form.on('submit(EditWatermark)', function(data){
              self.WatermarkID = data.elem.dataset.id;
              self.AddWatermarkTemplate(data.elem.dataset.id);
            });
            form.on('submit(DeleteWatermark)', function(data){
              self.DeleteWatermark(data.elem.dataset.id);
            });

            form.render();
          },
          yes: function(index, layero) {
            self.WatermarkList();
          }
        });
      },
      RenderWatermarkList () {
        var xml = ""
        for(let i in WatermarkList){
          xml += "<tr>"
            xml += "<td>"+WatermarkList[i].name+"</td>"
            xml += "<td>"
              if(WatermarkList[i].water_type == 1){
                xml += '<img src="'+WatermarkList[i].water_img+'" />'
              }else{
                xml += '<div style="font-size:'+WatermarkList[i].text_size+'px">'+WatermarkList[i].text+'</div>'
              }
            xml += "</td>"
            xml += "<td>"+WatermarkList[i].created_at+"</td>"
            xml += '<td class="btn-arr" style="width:140px">'
              xml += '<button type="button" class="layui-btn" lay-submit data-id="'+WatermarkList[i].id+'" lay-filter="EditWatermark">编辑</button>'
              xml += '<button type="button" class="layui-btn layui-btn-danger" lay-submit data-id="'+WatermarkList[i].id+'" lay-filter="DeleteWatermark">删除</button>'
            xml += "</td>"
          xml += "</tr>"
        }
        $("#WatermarkList").html(xml);
        if(!WatermarkList){
          $(".WatermarkNull").show();
        }
      },
      DeleteWatermark (id) {
        let param = new URLSearchParams();
        param.append('id', id);

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/del_water/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.WatermarkList(true);
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      TranslationClick(pindex) {
        self.pix = pindex;
        if (self.list[pindex].data.isClick) {
          self.list[pindex].data.isClick = false;
        } else {
          self.list[pindex].data.isClick = true;
        }
      },
      SelectLanguage(pix,id,etype) {
        if (id) {
          let imgs = [];
          if(self.list[pix].data.etype == "pro"){
            for (let i in self.list[pix].data.images) {
              if (self.list[pix].data.images[i].isActive) {
                imgs.push(self.list[pix].data.images[i]);
              }
            }
          }else{
            for (let i in self.list[pix].data.tier_variations[0].images) {
              if (self.list[pix].data.tier_variations[0].images[i].isActive) {
                imgs.push(self.list[pix].data.tier_variations[0].images[i]);
              }
            }
          }
          if (imgs.length > 0) {
            self.TranslationImg(id,etype);
          } else {
            self.ToastFun(1, '请先选择图片！'); //弹窗提醒
          }
        }
      },
      TranslationImg(lang,etype) {
        self.loading = true;
        let param = new URLSearchParams();
        param.append('lang', lang);
        if(self.list[self.pix].data.etype == "pro"){
          param.append('images', JSON.stringify(self.list[self.pix].data.images));
        }else{
          param.append('images', JSON.stringify(self.list[self.pix].data.tier_variations[0].images));
        }
        let _url = "/translation_img/";
        if(etype == 0){
          _url = "/translation_img_free/"
        }
        axios({
          method: 'post',
          url: self.GetServerUrl() + _url,
          data: param,
          timeout: 60000,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.isClick = false;
            if(self.list[self.pix].data.etype == "pro"){
              self.list[self.pix].data.images = datas;
            }else{
              self.list[self.pix].data.tier_variations[0].images = datas;
            }
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      mouseLeave(pix) {
        self.list[pix].data.isClick = false;
      },
      WebPicture(pix, etype, ix) {
        let picbox = layer.prompt({
          title: '添加网络地址',
          formType: 2,
          area: ['600px', '200px']
        }, function(pass, index) {
          if (etype == "pro") {
            if(pix = "all"){
              self.common.image = pass;
              self.$forceUpdate();
            }else{
              self.list[pix].data.images.push({
                isActive: false,
                url: pass
              });
            }
          }else if(etype = "size"){
            self.list[pix].data.size_chart_info.size_chart = pass;
          } else {
            self.list[pix].data.tier_variations[0].images[ix].url = pass;
            self.$forceUpdate();
          }
          layer.close(picbox);
        });
      },
      PictureSelection (pix,etype,title,ix) {
        var w, h;
        self.etype = etype;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        var PictureSpace = layer.open({
          type: 1,
          offset: '100px',
          title: title,
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定', '取消'],
          content: PictureSelectionHtml,
          skin: 'picture-space-module',
          success: function() {
            if(title == "产品图片"){
              self.ShowSpaceList(self.list[pix].data.images)
              $(".PictureSpaceCount").text(self.list[pix].data.images.length);
            }else{
              self.GetSpacePicture(1);
            }
          },
          yes: function(index, layero) {
            $(".space-box").each(function(){
              let isActive = $(this).attr("data-active");
              if(JSON.parse(isActive)){
                let img = $(this).find(".col-img").attr("data-img");
                if(etype == "pro"){
                  if(pix == "all"){
                    self.common.image = img;
                  }else{
                    self.list[pix].data.images.push({
                      isActive: false,
                      url: img
                    });
                  }
                }else if(etype == 'size'){
                  self.list[pix].data.size_chart_info.size_chart = img;
                }else{
                  self.list[pix].data.tier_variations[0].images[ix].url = img;
                }
              }
            })
            self.Spaceimgs = [];
            self.$forceUpdate();
            layer.close(PictureSpace);
          },
          btn2: function () {
            self.Spaceimgs = [];
          }
        });
      },
      GetSpacePicture(page) {
        self.isLoding = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/user_space/?page="+page,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if (datas.page) {
              let list = datas.list;
              $(".PictureSpaceCount").text(datas.page.count);
              self.ShowSpaceList(list);

               //分页
              $(".picture-space-module").find(".layui-layer-btn").css("position","relative").append('<div id="SpacePage"></div>');
              self.ShowSpacePage(self, laypage, "GetSpacePicture",datas.page);
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          console.log(error);
        })
      },
      ShowSpaceList (imgs) {
        var xml = "";
        for(let i in imgs){
          xml += "<li class='space-box' data-active='false'>"
          xml += '<p class="col-img layui-form" data-img="' + this.$picture(imgs[i].url) +
            '" style="background-image: url(' + this.$picture(imgs[i].url) + ')">'
          xml += '<i class="col-select"><input class="col-select-checkbox" type="checkbox" lay-skin="primary"></i>'
          xml += '<a class="space-select-box NoSelect" data-ix="'+i+'"></a>'
          xml += '</p>'
          xml += "</li>"
        }
        $(".module-img-list").html(xml);
        form.render();
      },
      TitleCheck (pix,etype) {
        var len;
        if(etype == 1){
          var min = 15,max = 180;
        }else{
          var min = 20,max = 5000;
        }
        if(pix == 'all'){
          if(etype == 1){
            len = self.GetBytesLength(self.common.name);
            self.common.namelength = self.GetBytesLength(self.common.name);
          }else{
            len = self.GetBytesLength(self.common.description);
            self.common.deslength = self.GetBytesLength(self.common.description);
          }
        }else if (pix == 'list') {
          for(let i in self.list){
            self.TitleCheck(i,1);
            self.TitleCheck(i,2);
          }
        }else{
          if(etype == 1){
            len = self.GetBytesLength(self.list[pix].data.name);
            self.list[pix].data.namelength = self.GetBytesLength(self.list[pix].data.name);
          }else{
            len = self.GetBytesLength(self.list[pix].data.description);
            self.list[pix].data.deslength = self.GetBytesLength(self.list[pix].data.description);
          }
        }
        if(len <= 0){
          return;
        }
        if(pix == 'all'){
          if(etype == 1){
            self.common.titleHint = false;
            if(len < min){
              self.common.titleHintTxt = "商品标题过短，请输入至少 "+min+" 个字符！"
              self.common.titleHint = true;
            }else if(len > max){
              self.common.titleHintTxt = "商品标题过短，请输入最多 "+max+" 个字符！"
              self.common.titleHint = true;
            }
            let name = self.common.name;
            if(name.substring(0,1) == " " || name.substring(name.length-1,name.length) == " "){
              self.common.titleHint = true;
              self.common.titleHintTxt = "此字段的开头或结尾不允许使用白色空格！"
            }
          }else{
            self.common.desHint = false;
            if(len < min){
              self.common.desHintTxt = "商品描述过短，请输入至少 "+min+" 个字符！"
              self.common.desHint = true;
            }else if(len > max){
              self.common.desHintTxt = "商品描述过短，请输入最多 "+max+" 个字符！"
              self.common.desHint = true;
            }
          }
        } else if (pix != 'list'){
          if(etype == 1){
            self.list[pix].data.titleHint = false;
            if(len < min){
              self.list[pix].data.titleHintTxt = "商品标题过短，请输入至少 "+min+" 个字符！"
              self.list[pix].data.titleHint = true;
            }else if(len > max){
              self.list[pix].data.titleHintTxt = "商品标题过长，请输入最多 "+max+" 个字符！"
              self.list[pix].data.titleHint = true;
            }
            let name = self.list[pix].data.name;
            if(name.substring(0,1) == " " || name.substring(name.length-1,name.length) == " "){
              self.list[pix].data.titleHint = true;
              self.list[pix].data.titleHintTxt = "此字段的开头或结尾不允许使用白色空格！"
            }
          }else{
            self.list[pix].data.desHint = false;
            if(len < min){
              self.list[pix].data.desHintTxt = "商品描述过短，请输入至少 "+min+" 个字符！"
              self.list[pix].data.desHint = true;
            }else if(len > max){
              self.list[pix].data.desHintTxt = "商品描述过长，请输入最多 "+max+" 个字符！"
              self.list[pix].data.desHint = true;
            }
          }
        }
      },
      TitleCheckStart (etype) {
        if(etype == 1){
          if(self.common.name){
            self.TitleCheck('all',1);
          }
        }else{
          if(self.common.description){
            self.TitleCheck('all',2);
          }
        }
      },
      TitleCheckEnd (etype) {
        if(etype == 1){
          self.common.titleHint = false;
        }else{
          self.common.desHint = false;
        }
      },
      GetImgsInfo(datalist) {
        var data_obj = JSON.parse(JSON.stringify(datalist)); //切断双向绑定联系

        var imgloadix = 0,imgobj = {};
        for (let i in data_obj) {

          //图片属性储存器
          if (!imgobj.hasOwnProperty(i)) {
            imgobj[i] = []
          }

          var imgix = 0;
          for (let x in data_obj[i].data.images) {

            //判断对象中是否已经获取过图片size
            if (!data_obj[i].data.images[x].hasOwnProperty("size")) {
              if (!imgobj[i].hasOwnProperty(x)) {
                imgobj[i][x] = []
              }
            }

            //图片对象赋值
            imgobj[i][x] = new Image()
            imgobj[i][x].src = data_obj[i].data.images[x].url;
            imgobj[i][x].onload = function() {
              imgix++;

              if (data_obj[imgloadix].data.images.length == imgix) { //某组数据图片加载完毕触发

                for (let y in data_obj[imgloadix].data.images) { //将加载完毕的图片尺寸赋值给对象
                  if(imgobj[imgloadix][y].width == 0 || imgobj[imgloadix][y].height == 0){
                    data_obj[imgloadix].data.images[y].size =null;
                  }else{
                    data_obj[imgloadix].data.images[y].size = imgobj[imgloadix][y].width + "x" + imgobj[imgloadix][y].height;
                  }
                }
                imgloadix++, imgix = 0; //切换数据对象，清空图片索引

                if (data_obj.length == imgloadix) { //所有数据对象图片加载完毕
                  for(let z in self.list){
                    self.list[z].data.images = JSON.parse(JSON.stringify(data_obj[z].data.images));
                    self.list_Backup[z].data.images = JSON.parse(JSON.stringify(data_obj[z].data.images));
                  }
                  self.$forceUpdate();
                }

              }
            }

          }
        }
      },
      AutoSku (pix,ix) {
        for(let i in self.list[pix].data.tier_variations[ix].options){
          self.EditFun(pix, ix, i, "#"+(Number(i)+1));
        }
      },
      AllUnitConversion () {
        for(let x in self.list){
          for(let y in self.list[x].data.tier_variations){
            self.UnitConversion(x,y);
          }
        }
        layer.msg("全部转换完成！");
      },
      UnitConversion (pix,ix) {
        let list = self.list[pix].data.tier_variations[ix].options;
        let size_list = self.SizeList();
        let sku_name,isConversion = false;
        for(let i in list){
          let size_arr = list[i].replace(/[^0-9]/ig," ");
          let arr = size_arr.split(" ");

          //判断是否有体重需要转换
          if(list[i].search("斤") > 0 || isConversion){
            isConversion = true;
          }else{
            continue;
          }

          //尺码匹配
          let size_name;
          for(let x in size_list){
            let patt = new RegExp(size_list[x],'i');
            let return_obj = patt.exec(list[i]);
            if(return_obj && return_obj.length > 0){
              size_name = return_obj[0];
            }
          }

          for (let x = arr.length - 1; x >= 0; x--) {
            if (!arr[x] || arr[x].length <= 1) {
              arr.splice(x, 1);
            }else{
              arr[x] /= 2;
            }
          }

          //判断是否有体重
          if(arr.length <= 0){
            continue;
          }

          //如果没有匹配尺码，自动填充
          if(!size_name){
            size_name = size_list[i];
          }
          if(arr.length >= 2){
            sku_name = size_name +": "+ arr[0] +'-'+ arr[1] + 'kg'
          }else{
            sku_name = size_name +": "+ arr[0] + 'kg以内'
          }

          self.EditFun(pix, ix, i, sku_name);
        }
      },
      SetUsedClassify () {
        self.loading = true;
        let param = new URLSearchParams();
        param.append('shop_id', self.shop.id);
        param.append('data', JSON.stringify(self.common.categories));

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/category_use_store/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            layer.msg("设置成功！");
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      ShowUsedClassify (pix) {
        self.pix = pix;
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        xmlModule = layer.open({
          type: 1,
          offset: '100px',
          title: "常用分类",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          content: UsedClassify,
          success: function() {
            self.LoadUsedClassify(1);

            form.on('submit(SelectUsedClassify)', function(data) {
              let categories = self.UsedClassify[data.elem.dataset.ix].data;
              if(pix == 'all'){
                self.common.categories = categories;
                self.common.isSpecial = categories[categories.length - 1].category_type;
              }else{
                self.list[pix].data.categories = categories;
                self.list[pix].data.isSpecial = categories[categories.length - 1].category_type; //货物类型
              }
              self.get_attributes(categories[categories.length - 1].catid); //加载商品属性
              layer.close(xmlModule);
            });

            form.on('submit(DeleteUsedClassify)', function(data) {
              self.DeleteUsedClassify(data.elem.dataset.id);
            });

          },
          yes: function(index, layero) {

          }
        });
      },
      LoadUsedClassify (page) {
        self.loading = true;
        let param = new URLSearchParams();
        param.append('shop_id', self.shop.id);
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/category_use/?page=" + page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          self.loading = false;
          var json = res.data;
          if (json.code == 200) {
            self.UsedClassify = json.datas;
          }
          self.ShowUsedClassifyXml(json.datas)
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      ShowUsedClassifyXml(datas) {
        var xml = ""
        console.log(datas)
        for (let i in datas) {
          datas[i].data = JSON.parse(datas[i].data);
          xml += "<tr>"
          xml += "<td>"
          xml += "<div class='col-classify'>"
          for(let x in datas[i].data){
            xml += "<a>"
            if(datas[i].data[x].display_name_zh){
              xml += '<i>'+datas[i].data[x].display_name_zh+'「'+datas[i].data[x].display_name+'」</i>'
            }else{
              xml += '<i>'+datas[i].data[x].display_name+'</i>'
            }
            if(x != (datas[i].data.length-1)){
              xml += "<i>> </i>"
            }
            xml += "</a>"
          }
          xml += "</div>"
          xml += "</td>"
          xml += "<td>" + datas[i].created_at + "</td>"
          xml += '<td class="btn-arr" style="width:140px">'
          xml += '<button type="button" class="layui-btn" lay-submit data-ix="'+i+'" lay-filter="SelectUsedClassify">选择</button>'
          xml += '<button type="button" class="layui-btn layui-btn-danger" lay-submit data-id="'+datas[i].id+'" lay-filter="DeleteUsedClassify">删除</button>'
          xml += "</td>"
          xml += "</tr>"
        }
        $("#UsedClassify").html(xml);
        if (!datas) {
          $(".WatermarkNull").show();
        }
      },
      DeleteUsedClassify(id) {
        let param = new URLSearchParams();
        param.append('id', id);

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/category_use_del/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.LoadUsedClassify(true);
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      SetUsedSku (pix) {
        self.loading = true;
        let param = new URLSearchParams();
        param.append('data', JSON.stringify(self.list[pix].data));

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/sku_use_store/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            layer.msg("收藏成功！");
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      ShowUsedSku (pix) {
        self.pix = pix;
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
        };
        xmlModule = layer.open({
          type: 1,
          offset: '100px',
          title: "常用SKU",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          content: UsedSku,
          success: function() {
            self.LoadUsedSku(1);

            form.on('submit(SelectUsedSku)', function(data) {
              let datas = self.UsedSku[data.elem.dataset.ix].data;
              if(pix == "all"){
                for(let i in self.list){
                  for (let v in datas.tier_variations) {
                    let lenArr = [];
                    for(let t in datas.tier_variations[v].options){
                      lenArr.push(self.GetBytesLength(datas.tier_variations[v].options[t]))
                    }
                    datas.tier_variations[v].len = lenArr;
                  }
                  self.list[i].data.is_tier_variations = datas.is_tier_variations;
                  self.list[i].data.tier_variations = datas.tier_variations;
                  self.list[i].data.customize_tier_variations = datas.customize_tier_variations;
                  self.list[i].data.models = datas.models;
                }
              }else{
                for (let v in datas.tier_variations) {
                  let lenArr = [];
                  for(let t in datas.tier_variations[v].options){
                    lenArr.push(self.GetBytesLength(datas.tier_variations[v].options[t]))
                  }
                  datas.tier_variations[v].len = lenArr;
                }
                self.list[pix].data.is_tier_variations = datas.is_tier_variations;
                self.list[pix].data.tier_variations = datas.tier_variations;
                self.list[pix].data.customize_tier_variations = datas.customize_tier_variations;
                self.list[pix].data.models = datas.models;
              }
              layer.msg("操作完成！");
              layer.close(xmlModule);
            });

            form.on('submit(DeleteUsedSku)', function(data) {
              self.DeleteUsedSku(data.elem.dataset.id);
            });

          },
          yes: function(index, layero) {

          }
        });
      },
      LoadUsedSku (page) {
        self.loading = true;
        let param = new URLSearchParams();
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/sku_use/?page=" + page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          self.loading = false;
          var json = res.data;
          if (json.code == 200) {
            self.UsedSku = json.datas;
          }
          self.ShowUsedSkuXml(json.datas)
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      ShowUsedSkuXml(datas) {
        var xml = ""
        console.log(datas)
        for (let i in datas) {
          datas[i].data = JSON.parse(datas[i].data);
          xml += "<tr>"
          xml += "<td>"
          xml += "<div class='col-classify'>"
          for(let y in datas[i].data.tier_variations){
            xml += "<div>"+datas[i].data.tier_variations[y].name+"："
            for(let z in datas[i].data.tier_variations[y].options){
              xml += "<a>【"+datas[i].data.tier_variations[y].options[z]+"】</a>"
            }
            xml += "</div>"
          }
          xml += "</div>"
          xml += "</td>"
          xml += "<td>" + datas[i].created_at + "</td>"
          xml += '<td class="btn-arr" style="width:140px">'
          xml += '<button type="button" class="layui-btn" lay-submit data-ix="'+i+'" lay-filter="SelectUsedSku">选择</button>'
          xml += '<button type="button" class="layui-btn layui-btn-danger" lay-submit data-id="'+datas[i].id+'" lay-filter="DeleteUsedSku">删除</button>'
          xml += "</td>"
          xml += "</tr>"
        }
        $("#UsedSku").html(xml);
        if (!datas) {
          $(".WatermarkNull").show();
        }
      },
      DeleteUsedSku(id) {
        let param = new URLSearchParams();
        param.append('id', id);

        axios({
          method: 'post',
          url: self.GetServerUrl() + "/sku_use_del/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.LoadUsedSku(true);
          }, false, true);
        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      TriggerPulldown (pindex,etype) {
        self.pix = pindex;
        self.list[pindex].data.etype = etype;
      },
      AllAutoSku () {
        var count = 0;
        for(let i in self.list){
          if(self.list[i].data.tier_variations.length == 1){
            if(self.list[i].data.tier_variations[0].options.length > 50){
              count++
              self.list[i].data.tier_variations[0].options.splice(50,self.list[i].data.tier_variations[0].options.length);
            }
          }else if(self.list[i].data.tier_variations.length == 2){
            if(self.list[i].data.tier_variations[0].options.length * self.list[i].data.tier_variations[1].options.length > 50){
              count++
            }

            for(let x=0;x<50;x++){
              var obj_one = self.list[i].data.tier_variations[0].options;
              var obj_img_one = self.list[i].data.tier_variations[0].images;
              var obj_two = self.list[i].data.tier_variations[1].options;
              var obj_img_two = self.list[i].data.tier_variations[1].images;
              var num = obj_one.length * obj_two.length; //当前SKU长度
              if(obj_two.length >= obj_one.length){  //属性二大于属性一
                if (num > 50) {
                  obj_two.splice(obj_two.length - 1, 1);
                  obj_img_two.splice(obj_two.length - 1, 1);
                }else{
                  break;
                }
              }else{
                if (num > 50) {
                  obj_one.splice(obj_one.length - 1, 1);
                  obj_img_one.splice(obj_one.length - 1, 1);
                }else{
                  break;
                }
              }
            }
          }
          self.CreateSkuArr(i, self.list[i].data);
        }
        if(count > 0){
          layer.msg("自动保留完成，成功操作商品 "+count+" 个");
        }else{
          layer.msg("商品无SKU超过50个！");
        }
        self.$forceUpdate();
      },
      AllAutoSkuLen () {
        for(let i in self.list){
          for(let x in self.list[i].data.tier_variations){
            var name;
            for(let y in self.list[i].data.tier_variations[x].options){
              let sku = self.list[i].data.tier_variations[x].options[y];

              if(self.GetBytesLength(sku) > 30){
                name = sku.substring(0,30);
                for(let z=0;z<sku.length;z++){
                  if(self.GetBytesLength(name) > 30){
                    name = name.substring(0,name.length-1);
                  }else{
                    continue;
                  }
                }

                self.EditFun(i, x, y, name);
              }
            }
          }
        }
        layer.msg("操作完成！");
      },
      GetPricing () {
        let pricing = self.pricing; //定价模板
        let cpricing; //当前选中模板
        for (let i in pricing) {
          if (pricing[i].is_select == 1) {
            cpricing = pricing[i];
          }
        }
        if(!cpricing && pricing.length > 0){
          cpricing = pricing[0]
        }
        return cpricing;
      },
      AllChangePrice () {
        let operator = $("#operator").val();
        if((!self.empty(self.common.price) && !isNaN(self.common.price)) || (!self.empty(self.common.priceCal) && !isNaN(self.common.priceCal))){
          for(let i in self.list){
            if(self.list[i].data.is_tier_variations){
              for(let x in self.list[i].data.customize_tier_variations){
                if((!self.empty(self.common.price) && !isNaN(self.common.price)) && (!self.empty(self.common.priceCal) && !isNaN(self.common.priceCal))){
                  self.list[i].data.customize_tier_variations[x].price = eval(self.common.price+operator+self.common.priceCal).toFixed(2);
                }else if((!self.empty(self.common.price) && !isNaN(self.common.price))){
                  self.list[i].data.customize_tier_variations[x].price = self.common.price;
                }else if((!self.empty(self.common.priceCal) && !isNaN(self.common.priceCal))){
                  self.list[i].data.customize_tier_variations[x].price = eval(self.list[i].data.customize_tier_variations[x].price+operator+self.common.priceCal).toFixed(2);
                }
                if(self.list[i].data.customize_tier_variations[x].price <= 0){
                  self.list[i].data.customize_tier_variations[x].price = 1;
                }
              }
            }
          }
          self.$forceUpdate();
        }
      },
      SkuLengthCheck (pindex) {
        for(let x in self.list[pindex].data.tier_variations){
          let lenArr = [];
          for(let t in self.list[pindex].data.tier_variations[x].options){
            lenArr.push(self.GetBytesLength(self.list[pindex].data.tier_variations[x].options[t]))
          }
          self.list[pindex].data.tier_variations[x].len = lenArr;
        }
      },
      PositionJump (id) {
        self.$nextTick(() => {
          let top = $("#"+id)[0].offsetTop;
          $('.BulkTopBox').animate({
            scrollTop: top + 'px'
          }, 200);
        });
      },
      AllImagesChange (etype) {
        if(etype == 1){
          let setmp = self.common.setmp;
          if(!self.empty(self.common.setmp)){
            setmp = parseInt(setmp)-1;
          }
          let delfp = self.common.delfp;
          let dellp = self.common.dellp;
          let first = self.common.first;
          let last = self.common.last;
          for(let i in self.list){
            if(!self.empty(setmp) && setmp < self.list[i].data.images.length){
              let img = self.list[i].data.images[0];
              self.list[i].data.images[0] = self.list[i].data.images[setmp];
              self.list[i].data.images[setmp] = img;
            }
            if(!self.empty(delfp)){
              self.list[i].data.images.splice(0,delfp);
            }
            if(!self.empty(dellp)){
              self.list[i].data.images.splice(dellp,self.list[i].data.images.length);
            }
            if(!self.empty(first) && !self.empty(last)){
              if(first > last){
                layer.msg("起始图片序号不能大于结束图片序号！");
                return;
              }
              let num = parseInt(last)+1 - first;
              self.list[i].data.images.splice(first-1,num);
            }
          }
        }else{
          if(self.common.image){
            let ix = $("#imgix").val()-1;
            for(let i in self.list){
              self.list[i].data.images.splice(ix, 0,{
                isActive: false,
                url: self.common.image
              });
            }
          }
        }
        layer.msg("操作完成！");
        self.$forceUpdate();
      },
      webpFilter (imgs){ //图片webp过滤
        for (var img in imgs) {
          if(imgs[img].url){
            var fix = imgs[img].url.length-4;
            var lix = imgs[img].url.length;
            var urlType = imgs[img].url.substring(fix,lix);
            if(urlType == "webp"){
              var imgix = imgs[img].url.lastIndexOf("jpeg?")+4;
              imgs[img].url = imgs[img].url.substring(0,imgix);
            }
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .layui-table {
    margin-top: 0;
  }

  .layui-select{
    width: 100%;
  }

  .shop-width {
    width: 200px;
  }

  .img-width {
    width: 100px !important;
  }

  .name-width {
    width: 250px;
  }

  .btnArr-width {
    width: 80px;
  }

  .BulkInput {
    padding: 0 10px;
    height: 30px;
    width: calc(100% - 20px);
    border: 1px solid #E3E3E3;
  }

  .BulkTextarea {
    width: 500px;
    height: 200px;
    padding: 8px 10px;
    border: 0;
    margin-bottom: 25px;
  }

  .img-list-row:first-child {
    margin-top: 0;
  }

  .paddingLeft {
    padding-left: 0;
  }

  .marginLeft {
    margin-left: 0 !important;
  }

  .marginTop {
    margin-top: 0 !important;
  }

  .Nopadding {
    padding: 0 !important;
  }

  .textarea-des{
    resize:vertical;
    padding:15px;
    overscroll-behavior: auto contain;
    height: 50px;
    padding-right: 100px;
    width: calc(100% - 115px);
  }
</style>



// WEBPACK FOOTER //
// src/components/product/BulkGlobal.vue